import React, { useState, useEffect, useCallback, useRef } from 'react';
import './FinalizarVenda.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, message, Select, Spin } from 'antd';
import PaymentScreen from './Pagamento/PaymentScreen';
import Pagamento from './Pagamento/Pagamento';
import axios from 'axios';
import Parametros from './Parametros';
import AcresDesc from './AcresDec/AcrescimoDescontoTotal';
import AcrescimoDescontoTotal from './AcresDec/AcrescimoDescontoTotal';
import IdentificarConsumidor from './FinalizarVenda/IdentificarConsumidor';
import { useConfigQuery } from '../../../queries/useConfig';
import axiosInstance from '../../../axiosInterceptor';
import { api } from '../../../config/api';


const FinalizarVenda = ({
  consumidorIdentificado,
  setConsumidorIdentificado,
  closeModal,
  nomeCupom,
  documentoCupom,
  setNomeCupom,
  setDocumentoCupom,
  consumidor,
  setConsumidor,
  precoTotal,
  pagamentoConcluido,
  setPagamentoConcluido,
  pagamentos,
  setPagamentos,
  produtos,
  setProdutos,
  subTotal,
  CalcularTotais,
  acresDescFrete,
  setAcresDescFrete,
  totalDescontos,
  totalAcrescimos,
  acresDescFreteConcluido,
  setAcresDescFreteConcluido,
  setPagItem,
  pagItem,
  travarAcrescimoDescFrete,
  cpfIntegracao,
  consumidorIntegrado,
  tokenPedidoTechsapp,
  setTokenPedidoTechsapp,
  formasDePagamento,
  idVendedorOrcamento,
  idOrcamento,
  setVendaPuxada,
  setIdPedidoMkt,
  idPedidoMkt,
  focarCodigoDeBarras,
  setMensagemTela,
  sessaoCaixa,
  parametros,
  setParametros,
  fatura,
  setFatura,
  infCpl,
  setInfCpl,
  mostrarCobranca,
  setMostrarCobranca
}) => {

  const { data: config, error } = useConfigQuery();
  const [isModalVisibleConsumidor, setIsModalVisibleConsumidor] = useState(false);
  const [isModalVisibleParametros, setIsModalVisibleParametros] = useState(false);
  const [isModalVisiblePagamento, setIsModalVisiblePagamento] = useState(false);
  const [isModalVisibleAcresDesc, setIsModalVisibleAcresDesc] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loja, setLoja] = useState('');
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const [serieDefault, setSerieDefault] = useState('');
  const [indPag, setIndPag] = useState('0');
  const [emailNota, setEmailNota] = useState('');
  const [telefoneEnvio, setTelefoneEnvio] = useState('');
  const [processamentoMsg, setProcessamentoMsg] = useState('');
  const [totalPago, setTotalPago] = useState(0);

  const [subTotalProdutos, setSubTotalProdutos] = useState(0);
  const [totalDescontosProdutos, setTotalDescontosProdutos] =
    useState(0);
  const [totalAcrescimosProdutos, setTotalAcrescimosProdutos] =
    useState(0);
  const [freteProdutos, setFreteProdutos] = useState(0);
  const [totalProdutos, setTotalProdutos] = useState(0);

  const [subTotalServicos, setSubTotalServicos] = useState(0);
  const [totalDescontosServicos, setTotalDescontosServicos] =
    useState(0);
  const [totalAcrescimosServicos, setTotalAcrescimosServicos] =
    useState(0);
  const [freteServicos, setFreteServicos] = useState(0);
  const [totalServicos, setTotalServicos] = useState(0);



  //Usuarios
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const habilitarSelecaoVendedor =
    config?.terminalComercial?.selecionarVendedorNaFinalizacao === true;

  useEffect(() => {
    console.log('pagItem:', pagItem);
  }, [pagItem]);

  useEffect(() => {
    const converterNumero = (valor) => {
      if (
        valor === null ||
        valor === undefined ||
        valor === ''
      ) {
        return 0;
      }

      if (typeof valor === 'number') {
        return Number.isFinite(valor) ? valor : 0;
      }

      const valorTexto = String(valor)
        .trim()
        .replace(/\s/g, '');

      const valorNormalizado =
        valorTexto.includes(',') &&
          valorTexto.includes('.')
          ? valorTexto
            .replace(/\./g, '')
            .replace(',', '.')
          : valorTexto.includes(',')
            ? valorTexto.replace(',', '.')
            : valorTexto;

      const numero = Number(valorNormalizado);

      return Number.isFinite(numero) ? numero : 0;
    };



    const arredondar = (valor) =>
      Math.round(
        (Number(valor) + Number.EPSILON) * 100
      ) / 100;

    const totaisProdutos = {
      subtotal: 0,
      descontos: 0,
      acrescimos: 0,
      frete: 0,
      total: 0,
    };

    const totaisServicos = {
      subtotal: 0,
      descontos: 0,
      acrescimos: 0,
      frete: 0,
      total: 0,
    };

    const listaProdutos = Array.isArray(produtos)
      ? produtos
      : [];

    listaProdutos.forEach((produto) => {
      const quantidade = converterNumero(
        produto?.quantidade
      );

      const preco = converterNumero(
        produto?.preco
      );

      const desconto = converterNumero(
        produto?.valorDesconto ??
        produto?.desconto
      );

      const acrescimo = converterNumero(
        produto?.valorAcrescimo ??
        produto?.acrescimo
      );

      const frete = converterNumero(
        produto?.frete
      );

      const subtotalItem = arredondar(quantidade * preco);

      const totalItem =
        arredondar(subtotalItem +
          acrescimo +
          frete -
          desconto);

      const tipoItem =
        produto?.ntipoItem ??
        produto?.nTipoItem ??
        produto?.tipoItem ??
        0;

      const ehServico =
        String(tipoItem) === '5';

      const acumulador = ehServico
        ? totaisServicos
        : totaisProdutos;

      acumulador.subtotal += subtotalItem;
      acumulador.descontos += desconto;
      acumulador.acrescimos += acrescimo;
      acumulador.frete += frete;
      acumulador.total += totalItem;
    });

    setSubTotalProdutos(
      arredondar(totaisProdutos.subtotal)
    );

    setTotalDescontosProdutos(
      arredondar(totaisProdutos.descontos)
    );

    setTotalAcrescimosProdutos(
      arredondar(totaisProdutos.acrescimos)
    );

    setFreteProdutos(
      arredondar(totaisProdutos.frete)
    );

    setTotalProdutos(
      arredondar(totaisProdutos.total)
    );

    setSubTotalServicos(
      arredondar(totaisServicos.subtotal)
    );

    setTotalDescontosServicos(
      arredondar(totaisServicos.descontos)
    );

    setTotalAcrescimosServicos(
      arredondar(totaisServicos.acrescimos)
    );

    setFreteServicos(
      arredondar(totaisServicos.frete)
    );

    setTotalServicos(
      arredondar(totaisServicos.total)
    );
  }, [produtos, acresDescFrete]);


  const jaRodouRef = useRef(false);

  useEffect(() => {
    const run = async () => {
      if (!idPedidoMkt) return;
      if (jaRodouRef.current) return;

      jaRodouRef.current = true;
      await emitirCupomNFE();
    };

    run();
  }, [idPedidoMkt]);


  const toggleModalIdentificarConsumidor = () => {
    setIsModalVisibleConsumidor(!isModalVisibleConsumidor);
  };

  const toggleModalParametros = () => {
    setIsModalVisibleParametros(!isModalVisibleParametros);
  };

  const toggleModalPagamento = () => {
    setIsModalVisiblePagamento(!isModalVisiblePagamento);
  };

  const toggleModalAcresDesc = () => {
    setIsModalVisibleAcresDesc(!isModalVisibleAcresDesc);
  };

  const [
    acrescimoDescontosFreteConcluido,
    setAcrescimoDescontosFreteConcluido,
  ] = useState(false);

  const obterDocumentoAutorizado = ({
    response,
    modelo,
  }) => {
    const doc = response?.data?.documento;

    if (!doc) {
      throw new Error(
        response?.data?.detail ||
        response?.data?.error ||
        response?.data?.message ||
        `A API não retornou o documento da ${modelo}.`
      );
    }

    if (Number(doc.sitCodigo) !== 100) {
      throw new Error(
        doc.sitDescricao ||
        doc.sitMensagem ||
        doc.xMotivo ||
        doc.motivo ||
        doc.message ||
        `${modelo} rejeitada. Código ${doc.sitCodigo}.`
      );
    }

    return doc;
  };



  function fmt2(v) { return Number(v).toFixed(2); }
  function fmt3(v) { return Number(v).toFixed(3); }

  const cancelarDocumentoFiscal = async ({
    chaveDocFiscal,
    modelo,
    motivo,
  }) => {
    if (!chaveDocFiscal) {
      throw new Error(
        `Não foi possível cancelar ${modelo}: chave não informada.`
      );
    }

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };

    const body = {
      mensagem:
        motivo ||
        'Cancelado pois haviam erros no outro documento fiscal.',
    };

    let url =
      `${api.technfe}/v1/nota/cancelarNota/${chaveDocFiscal}`;

    if (modelo === 'NFSE') {
      url =
        `${api.technfservico}/nfse/cancelarNotaDireto/${chaveDocFiscal}`;
    }

    const response = await axios.post(
      url,
      body,
      options
    );

    console.log(
      `${modelo} cancelada com sucesso:`,
      response.data
    );

    return response.data;
  };

  function calcularVBCDefault(produto) {
    return (produto.quantidade * produto.preco) +
      (produto.valorAcrescimo || 0) -
      (produto.valorDesconto || 0);
  }

  function buildPIS(produto, vBCOverride) {
    const cst = String(produto.cstPis ?? '01').padStart(2, '0');
    const out = { CST_pis: cst };

    // PIS não tributado – só CST
    if (['04', '06', '07', '08', '09', '49', '03', '99'].includes(cst)) return out;

    // CST 01/02 (alíquota %)
    if (cst === '01' || cst === '02') {
      const vBC = vBCOverride != null
        ? Number(vBCOverride)
        : Number(produto.vBC_pis) || calcularVBCDefault(produto);

      const p = Number(produto.ppis);
      const v = produto.vPIS != null ? Number(produto.vPIS) : vBC * (p / 100);

      return {
        ...out,
        vBC_pis: fmt2(vBC),
        pPIS: fmt2(p),
        vPIS: fmt2(v),
      };
    }
    /*
      // CST 03 (quantidade)
      if (cst === '03') {
        const q = Number(produto.qBCProd_pis || produto.quantidade);
        const vAliq = Number(produto.vAliqProd_pis);
        const v = produto.vPIS != null ? Number(produto.vPIS) : q * vAliq;
    
        return {
          ...out,
          qBCProd_pis: fmt3(q),
          vAliqProd_pis: fmt2(vAliq),
          vPIS: fmt2(v),
        };
      }
    
      // CST 99 (outras operações)
      if (cst === '99') {
        const p = Number(produto.ppis);
        const temPercentual = p > 0;
    
        if (temPercentual) {
          const vBC = vBCOverride != null
            ? Number(vBCOverride)
            : Number(produto.vBC_pis) || calcularVBCDefault(produto);
          const v = produto.vPIS != null ? Number(produto.vPIS) : vBC * (p / 100);
    
          return {
            ...out,
            vBC_pis: fmt2(vBC),
            pPIS: fmt2(p),
            vPIS: fmt2(v),
          };
        } else {
          const q = Number(produto.qBCProd_pis || produto.quantidade);
          const vAliq = Number(produto.vAliqProd_pis);
          const v = produto.vPIS != null ? Number(produto.vPIS) : q * vAliq;
    
          return {
            ...out,
            qBCProd_pis: fmt3(q),
            vAliqProd_pis: fmt2(vAliq),
            vPIS: fmt2(v),
          };
        }
      }
    */
    // Demais CST
    return out;
  }


  const buildIBSCBS = (produto, vBc) => {
    console.log(produto);

    const toNumber = (v) => {
      if (v === null || v === undefined || v === '') return 0;

      const s = String(v).trim().replace(/\s/g, '');
      const norm =
        s.includes(',') && s.includes('.')
          ? s.replace(/\./g, '').replace(',', '.')
          : s.includes(',') && !s.includes('.')
            ? s.replace(',', '.')
            : s;

      const n = Number(norm);
      return Number.isFinite(n) ? n : 0;
    };

    const fmt2 = (n) => toNumber(n).toFixed(2);
    const fmt4 = (n) => toNumber(n).toFixed(4);

    const qtd = toNumber(produto?.quantidade ?? 1);
    const preco = toNumber(produto?.preco ?? 0);

    const acrescimo = toNumber(produto?.valorAcrescimo ?? produto?.acrescimo ?? 0);
    const desconto = toNumber(produto?.valorDesconto ?? produto?.desconto ?? 0);
    const frete = toNumber(produto?.frete ?? 0);

    const vBC_num = toNumber(vBc) || preco * qtd + acrescimo + frete - desconto;

    const pIBSUF_num = toNumber(produto?.pibsuf ?? 0);
    const pIBSMun_num = toNumber(produto?.pibsMun ?? 0);
    const pCBS_num = toNumber(produto?.pcbs ?? 0);

    const vIBSUF_num = vBC_num * (pIBSUF_num / 100);
    const vIBSMun_num = vBC_num * (pIBSMun_num / 100);
    const vIBS_num = vIBSUF_num + vIBSMun_num;
    const vCBS_num = vBC_num * (pCBS_num / 100);

    const CST = produto?.ibscbsCst;
    const cClassTrib = produto?.cclassTrib;

    return {
      IBSCBS: {
        IBSCBS: {
          CST,
          cClassTrib,
          gIBSCBS: {
            vBC: fmt2(vBC_num),
            gIBSUF: {
              pIBSUF: fmt4(pIBSUF_num),
              vIBSUF: fmt2(vIBSUF_num),
            },
            gIBSMun: {
              pIBSMun: fmt4(pIBSMun_num),
              vIBSMun: fmt2(vIBSMun_num),
            },
            vIBS: fmt2(vIBS_num),
            gCBS: {
              pCBS: fmt4(pCBS_num),
              vCBS: fmt2(vCBS_num),
            },
          },
        },
      },

      totais: {
        vIBSUF: vIBSUF_num,
        vIBSMun: vIBSMun_num,
        vCBS: vCBS_num,
      },
    };
  };


  function buildCOFINS(produto, vBCOverride) {
    const cst = String(produto.cstCofins ?? '01').padStart(2, '0');
    const out = { CST_cofins: cst };

    // COFINS não tributado – só CST
    if (['04', '06', '07', '08', '09', '49', '03', '99'].includes(cst)) return out;

    // 01/02 – alíquota percentual
    if (cst === '01' || cst === '02') {
      const vBC = vBCOverride != null
        ? Number(vBCOverride)
        : Number(produto.vBC_cofins) || calcularVBCDefault(produto);

      const p = Number(produto.pcofins);
      const v = produto.vCOFINS != null ? Number(produto.vCOFINS) : vBC * (p / 100);

      return {
        ...out,
        vBC_cofins: fmt2(vBC),
        pCOFINS: fmt2(p),
        vCOFINS: fmt2(v),
      };
    }
    /*
      // 03 – por quantidade
      if (cst === '03') {
        const q = Number(produto.qBCProd_cofins || produto.quantidade);
        const vAliq = Number(produto.vAliqProd_cofins);
        const v = produto.vCOFINS != null ? Number(produto.vCOFINS) : q * vAliq;
    
        return {
          ...out,
          qBCProd_cofins: fmt3(q),
          vAliqProd_cofins: fmt2(vAliq),
          vCOFINS: fmt2(v),
        };
      }
    
      // 99 – outras operações (percentual OU quantidade)
      if (cst === '99') {
        const p = Number(produto.pcofins);
        const temPercentual = p > 0;
    
        if (temPercentual) {
          const vBC = vBCOverride != null
            ? Number(vBCOverride)
            : Number(produto.vBC_cofins) || calcularVBCDefault(produto);
          const v = produto.vCOFINS != null ? Number(produto.vCOFINS) : vBC * (p / 100);
    
          return {
            ...out,
            vBC_cofins: fmt2(vBC),
            pCOFINS: fmt2(p),
            vCOFINS: fmt2(v),
          };
        } else {
          const q = Number(produto.qBCProd_cofins || produto.quantidade);
          const vAliq = Number(produto.vAliqProd_cofins);
          const v = produto.vCOFINS != null ? Number(produto.vCOFINS) : q * vAliq;
    
          return {
            ...out,
            qBCProd_cofins: fmt3(q),
            vAliqProd_cofins: fmt2(vAliq),
            vCOFINS: fmt2(v),
          };
        }
      }
    */
    // Demais CST
    return out;
  }


  const criarEvento = async (venda) => {
    setProcessamentoMsg('Gerando documentos fiscais...');
    let erroBol = false;
    console.log('dentro do criarEvento');

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken, // Certifique-se de definir `accessToken`
      },
    };

    try {
      const response = await axios.post(
        `${api.techspdv}/v1/pdveventos/venda`,
        venda,
        options
      );

      if (response.data) {
        console.log('Requisição bem-sucedida');
        await deletarLog(venda.InfoSistema.chaveDocFiscal);
        return response;
      }
    } catch (error) {
      erroBol = true;

      // Tratamento de erro
      if (error.response) {
        console.log('Status de erro:', error.response.status);
        console.log('Dados de erro:', error.response.data);

        const retry = window.confirm(
          'Falha ao gravar o histórico. Deseja tentar novamente?'
        );

        if (retry) {
          console.log('Tentar novamente');
          return await criarEvento(venda);
        } else {
          console.log('Usuário escolheu não tentar novamente.');
          // Realizar ações adicionais se o usuário escolher não tentar novamente
          setLoading(false);
          setVendaPuxada(false);
          focarCodigoDeBarras();
          closeModal();
          setProdutos([]);
          setConsumidor(null);
          setNomeCupom('');
          setDocumentoCupom('');
          setConsumidorIdentificado(false);
          return null;
        }
      }

      console.error('Erro inesperado:', error);
      return null;
    }
  };

  function formatarTelefone(numero) {
    const apenasNumeros = numero.replace(/\D/g, '');

    if (apenasNumeros.length === 13) {
      // Ex: 55 11 91234-5678
      return `+${apenasNumeros.slice(0, 2)} (${apenasNumeros.slice(2, 4)}) ${apenasNumeros.slice(4, 9)}-${apenasNumeros.slice(9)}`;
    } else if (apenasNumeros.length === 11) {
      // Ex: 11 91234-5678
      return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 7)}-${apenasNumeros.slice(7)}`;
    } else if (apenasNumeros.length === 10) {
      // Ex: 11 1234-5678
      return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 6)}-${apenasNumeros.slice(6)}`;
    } else {
      // Retorna o número cru se não casar
      return numero;
    }
  }
  const buscarUsuarios = async () => {
    if (!config?.idLoja) return;

    try {
      setLoadingUsuarios(true);

      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      const response = await axios.get(
        `${api.techfood}/v1/restaurantes/${config.idLoja}/responsaveis`,
        options
      );

      const lista = response.data?._embedded?.usuarios || [];

      // opcional: mostra somente usuários ativos e não bloqueados
      const usuariosValidos = lista.filter(
        (usuario) =>
          usuario.ativo === true &&
          usuario.bloqueio === false
      );

      setUsuarios(usuariosValidos);

      // deixa o usuário logado selecionado automaticamente
      const usuarioLogado = usuariosValidos.find(
        (usuario) =>
          String(usuario.id) === String(idUser)
      );

      if (usuarioLogado) {
        setUsuarioSelecionado(usuarioLogado.id);
      }

    } catch (error) {
      console.error('Erro ao buscar usuários:', error);

      message.error(
        'Não foi possível carregar os usuários da loja.'
      );

      setUsuarios([]);
    } finally {
      setLoadingUsuarios(false);
    }
  };
  useEffect(() => {
    if (
      habilitarSelecaoVendedor &&
      config?.idLoja
    ) {
      buscarUsuarios();
    }
  }, [
    habilitarSelecaoVendedor,
    config?.idLoja,
  ]);

  const gravarLog = async (venda, response) => {

    try {

      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      const body = {
        lojaId: config.restaurante.id,
        log: JSON.stringify(venda),
        numeroNota: venda.InfoSistema.numeroDocFiscal,
        chaveNota: venda.InfoSistema.chaveDocFiscal
      }

      const response = await axios.post(
        `${api.techspdv}/v1/logs`, body,
        options
      );

      console.log(response.data);

    } catch (error) {
      console.error('Erro ao acessar o localStorage:', error);
    }
  }
  const deletarLog = async (chaveNota) => {
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };
      const response = await axios.delete(
        `${api.techspdv}/v1/logs/chave/${chaveNota}`,
        options
      );
      console.log(response.data);
    } catch (error) {
      console.error('Erro ao acessar o localStorage:', error);
    }
  }

  const sharingPdf = async (chaveDocFiscal, modelo) => {
    console.log(chaveDocFiscal);
    console.log(modelo);

    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };
      let urlAux = `${api.technfe}/v1/historico/chave/${chaveDocFiscal}`;

      if (modelo == 'NFSE') {
        urlAux = `${api.technfservico}/v1/historico/chave/${chaveDocFiscal}`;
      }
      const response = await axios.get(
        urlAux,
        options
      );

      // Decodifica o PDF base64 para um blob
      const pdfBase64 = response.data._embedded.historico[0].pdfBase64;
      const binaryData = atob(pdfBase64);
      const byteNumbers = new Uint8Array(
        binaryData.split('').map((char) => char.charCodeAt(0))
      );
      const blob = new Blob([byteNumbers], { type: 'application/pdf' });

      // Cria uma URL para o blob e inicia o download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${modelo}_${chaveDocFiscal}.pdf`;
      document.body.appendChild(link);
      link.click();

      // Remove o link da DOM
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao carregar historico:', error);
    }
  };

  function downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'documento.xml';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  const baixarXmlComoTexto = async (xmlUrl) => {
    const res = await fetch(xmlUrl, {
      method: "GET",
      // às vezes precisa mandar Accept
      headers: { Accept: "application/xml,text/xml,*/*" },
    });

    const contentType = res.headers.get("content-type") || "";
    const bodyText = await res.text();

    // validação simples pra não mandar HTML achando que é XML
    const pareceXml = bodyText.trim().startsWith("<?xml") || bodyText.includes("<NFe") || bodyText.includes("<nfeProc");
    if (!pareceXml) {
      throw new Error(
        `Resposta não parece XML. content-type=${contentType}. Provável HTML/login/erro.`
      );
    }

    return bodyText;
  }
  const downloadXmlViaIframe = async (xmlUrl) => {
    if (!xmlUrl) return;

    // cria iframe escondido
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = xmlUrl;

    // opcional: limpar depois de alguns segundos
    const cleanup = () => {
      setTimeout(() => {
        try { document.body.removeChild(iframe); } catch { }
      }, 15000);
    };

    iframe.onload = cleanup; // nem sempre dispara por cross-origin, mas não tem problema
    document.body.appendChild(iframe);
  }

  const possuiPagamento = pagItem?.length > 0;

  const obterResumoPagamentos = () => {
    if (!pagItem?.length) {
      return 'Nenhum pagamento';
    }

    return [
      ...new Set(
        pagItem.map((item) => item.xPag)
      ),
    ].join(' • ');
  };

  function sanitizeInfAdProd(text) {
    return String(text || "")
      .replace(/[\u0000-\u001F\u007F]/g, " ") // remove caracteres de controle
      .replace(/[<>&]/g, " ")                 // evita quebrar XML
      .replace(/\s+/g, " ")                   // normaliza espaços
      .trim()
      .slice(0, 500);                         // respeita limite do schema
  }
  function trataXProd(str1, str2) {
    const maxLen = 119;

    // normaliza entradas e remove quebras de linha
    str1 = String(str1 || "").replace(/[\r\n]+/g, " ").trim();
    str2 = String(str2 || "").replace(/[\r\n]+/g, " ").trim();

    // se str2 não vier nada, retorna só str1 (cortado no limite)
    if (!str2) {
      return str1.slice(0, maxLen);
    }

    // monta a string concatenada com " - "
    let result = `${str1} - ${str2}`;

    // aplica limite de 120 caracteres
    if (result.length > maxLen) {
      result = result.slice(0, maxLen);
    }

    return result;
  }

  function gerarIdUnico(cnpj) {
    return `${cnpj}-${Date.now().toString(36)}-${Math.random().toString(36).substr(2, 5)}`;
  }

  async function validarNota(
    venda,
    modelo,
    tentativa = 1,
    documentoAnterior = null,
    modeloAnterior = null
  ) {
    // Configuração única dos headers
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };

    try {
      // 1) Buscar histórico
      const urlHistorico =
        modelo === 'NFSE'
          ? `${api.technfservico}/v1/historico/sessao/${venda.InfoSistema.sessao}`
          : `${api.technfe}/v1/historico/sessao/${venda.InfoSistema.sessao}`;

      const historico = await axios.get(
        urlHistorico,
        options
      );


      console.log(`Tentativa ${tentativa}:`, historico.data);

      if (historico.data.length > 0) {
        const doc = historico.data[0];

        if (Number(doc?.sitCodigo) === 100) {
          console.log(
            'antes de compartilhar o pdf'
          );

          await sharingPdf(
            doc.docChaAcesso,
            modelo
          );

          venda.InfoSistema.chaveDocFiscal =
            doc.docChaAcesso;

          venda.InfoSistema.numeroDocFiscal =
            String(doc.docNumero);

          venda.InfoSistema.serieDocFiscal =
            String(doc.docSerie);

          venda.InfoSistema.docDhAut =
            doc.docDhAut;

          await gravarLog(venda);

          if (telefoneEnvio) {
            const respEnvio = await axios.get(
              `${api.techfood}/v1/envioWhatsapp/enviar/${doc.docChaAcesso}/${config.restaurante.id}/${telefoneEnvio}`,
              options
            );

            console.log(respEnvio.data);
          }

          const response2 =
            await criarEvento(venda);

          console.log(response2);

          if (response2?.data) {
            if (tokenPedidoTechsapp) {
              const optionsTechsapp = {
                headers: {
                  Accept: 'application/json',
                  'Content-Type':
                    'application/json',
                  Authorization:
                    `Basic ${config.restaurante.basic_token}`,
                },
              };

              const bodyConfirmacao = {
                chave_cupom:
                  config.restaurante.basic_token,

                numero_cupom:
                  config.restaurante.dominio,
              };

              await axios.post(
                `https://www.${config.restaurante.dominio}.com.br/backend/api/pdv/pedido/finalizarPedido/${tokenPedidoTechsapp}`,
                bodyConfirmacao,
                optionsTechsapp
              );
            }

            setTokenPedidoTechsapp(null);
            setProcessamentoMsg('');
            setLoading(false);
            setVendaPuxada(false);
            focarCodigoDeBarras();
            closeModal();

            setProdutos([]);
            setConsumidor(null);
            setNomeCupom('');
            setDocumentoCupom('');
            setConsumidorIdentificado(false);
          }

          return;
        }

        throw new Error(
          doc?.sitDescricao ||
          doc?.sitMensagem ||
          doc?.xMotivo ||
          doc?.motivo ||
          doc?.message ||
          `${modelo} encontrada, mas não autorizada. Código ${doc?.sitCodigo}.`
        );
      } else {
        // Se não encontrou nada e ainda não atingiu o limite de 3 tentativas
        if (tentativa < 3) {
          console.log(`⚠️ Nota não encontrada, tentando novamente em 5s... (tentativa ${tentativa + 1})`);
          setProcessamentoMsg(`⚠️ Nota não encontrada, tentando novamente em 5s... (tentativa ${tentativa + 1})`);



          setTimeout(
            () =>
              validarNota(
                venda,
                modelo,
                tentativa + 1,
                documentoAnterior,
                modeloAnterior
              ),
            5000
          );









        } else {
          console.error(
            `Não foi possível recuperar a ${modelo} após 3 tentativas.`
          );

          /*
           * Se existia outra nota autorizada antes da nota
           * que ficou sem confirmação, cancela a anterior.
           */
          if (
            documentoAnterior?.docChaAcesso &&
            modeloAnterior
          ) {
            try {
              setProcessamentoMsg(
                `Não foi possível confirmar a ${modelo}. Cancelando a ${modeloAnterior} anterior...`
              );

              await cancelarDocumentoFiscal({
                chaveDocFiscal:
                  documentoAnterior.docChaAcesso,

                modelo:
                  modeloAnterior,

                motivo:
                  `Cancelado pois não foi possível confirmar a emissão da ${modelo} após 3 tentativas.`,
              });

              message.warning(
                `Não foi possível confirmar a ${modelo}. A ${modeloAnterior} anterior foi cancelada automaticamente.`
              );
            } catch (errorCancelamento) {
              console.error(
                `Erro ao cancelar a ${modeloAnterior}:`,
                errorCancelamento
              );

              window.alert(
                `Não foi possível recuperar a ${modelo} e também não foi possível confirmar o cancelamento da ${modeloAnterior} anterior.\n\n` +
                `Chave: ${documentoAnterior.docChaAcesso}\n\n` +
                `Verifique o painel fiscal antes de tentar novamente.`
              );
            }
          } else {
            window.alert(
              `Não foi possível recuperar a ${modelo} após 3 tentativas.`
            );
          }

          setLoading(false);
          setProcessamentoMsg('');
        }
      }
    } catch (error) {
      console.error(
        `Erro na tentativa ${tentativa} de recuperar a ${modelo}:`,
        error
      );

      if (tentativa < 3) {
        setProcessamentoMsg(
          `Erro ao consultar a ${modelo}. Tentando novamente em 5 segundos... (${tentativa + 1}/3)`
        );

        setTimeout(
          () =>
            validarNota(
              venda,
              modelo,
              tentativa + 1,
              documentoAnterior,
              modeloAnterior
            ),
          5000
        );

        return;
      }

      /*
       * A consulta também falhou na última tentativa.
       * Cancela o documento anterior autorizado.
       */
      if (
        documentoAnterior?.docChaAcesso &&
        modeloAnterior
      ) {
        try {
          setProcessamentoMsg(
            `Não foi possível confirmar a ${modelo}. Cancelando a ${modeloAnterior} anterior...`
          );

          await cancelarDocumentoFiscal({
            chaveDocFiscal:
              documentoAnterior.docChaAcesso,

            modelo:
              modeloAnterior,

            motivo:
              `Cancelado pois não foi possível confirmar a emissão da ${modelo} após 3 tentativas.`,
          });

          message.warning(
            `Não foi possível confirmar a ${modelo}. A ${modeloAnterior} anterior foi cancelada automaticamente.`
          );
        } catch (errorCancelamento) {
          console.error(
            'Erro no cancelamento compensatório:',
            errorCancelamento
          );

          window.alert(
            `Não foi possível confirmar a ${modelo} nem cancelar automaticamente a ${modeloAnterior}.\n\n` +
            `Chave: ${documentoAnterior.docChaAcesso}\n\n` +
            `Verifique o painel fiscal.`
          );
        }
      } else {
        window.alert(
          `Não foi possível recuperar a ${modelo} após 3 tentativas.`
        );
      }

      setLoading(false);
      setProcessamentoMsg('');
    }
  }


  const paraCentavos = (valor) =>
    Math.round(Number(valor || 0) * 100);

  const paraReais = (valor) =>
    (valor / 100).toFixed(2);

  const separarPagamentos = ({
    pag,
    valorServico,
    valorProduto
  }) => {
    const pagamentos = structuredClone(
      pag?.pagItem || []
    );

    let restanteServico = paraCentavos(valorServico);
    const totalProduto = paraCentavos(valorProduto);

    /*
     * Mantém a ordem das formas de pagamento,
     * mas joga dinheiro para o final.
     */
    const pagamentosOrdenados = pagamentos.sort((a, b) => {
      const aDinheiro = String(a.tPag) === "01";
      const bDinheiro = String(b.tPag) === "01";

      if (aDinheiro === bDinheiro) {
        return 0;
      }

      return aDinheiro ? 1 : -1;
    });

    const pagServico = [];
    const pagProduto = [];

    for (const pagamento of pagamentosOrdenados) {
      const valorPagamento = paraCentavos(
        pagamento.vPag
      );

      const valorUsadoServico = Math.min(
        valorPagamento,
        restanteServico
      );

      if (valorUsadoServico > 0) {
        pagServico.push({
          ...structuredClone(pagamento),
          vPag: paraReais(valorUsadoServico),
        });

        restanteServico -= valorUsadoServico;
      }

      const valorRestante =
        valorPagamento - valorUsadoServico;

      if (valorRestante > 0) {
        pagProduto.push({
          ...structuredClone(pagamento),
          vPag: paraReais(valorRestante),
        });
      }
    }

    if (restanteServico > 0) {
      throw new Error(
        `Pagamento insuficiente para a nota de serviço. Faltam R$ ${paraReais(
          restanteServico
        )}.`
      );
    }

    const totalPagProduto = pagProduto.reduce(
      (total, item) =>
        total + paraCentavos(item.vPag),
      0
    );

    /*if (totalPagProduto !== totalProduto) {
      throw new Error(
        `Pagamento da nota de produto não corresponde ao valor da nota.` +
        `Nota: R$ ${paraReais(totalProduto)} | ` +
        `Pagamento: R$ ${paraReais(totalPagProduto)}`
      );
    }*/

    return {
      pagServico: {
        pagItem: pagServico,
      },
      pagProduto: {
        pagItem: pagProduto,
      },
    };
  };

  const emitirCupom = async () => {



    setLoading(true);
    setProcessamentoMsg('Preparando documentos fiscais...');

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };




    let modeloEmEmissao = null;
    let venda = null;
    let vendaServico = null;

    let temProdutos = false;
    let temServicos = false;

    let documentoProdutoAutorizado = null;
    let documentoServicoAutorizado = null;



    const limparVenda = () => {
      setTokenPedidoTechsapp(null);
      setProcessamentoMsg('');
      setMensagemTela('');
      setVendaPuxada(false);
      setLoading(false);
      setVendaPuxada(false);
      focarCodigoDeBarras();
      closeModal();

      setProdutos([]);
      setConsumidor(null);
      setNomeCupom('');
      setDocumentoCupom('');
      setConsumidorIdentificado(false);

      setAcresDescFrete({
        acresTotal: '0',
        descTotal: '0',
        frete: '0',
      });
      setPagItem(null);
    };

    try {
      /*
       * Separa os itens físicos dos serviços.
       *
       * nTipoItem = 5:
       * serviço destinado à NFS-e.
       *
       * Os demais tipos:
       * produtos destinados à NFC-e.
       */
      const produtosNormais = produtos.filter(
        (produto) =>
          String(produto.ntipoItem) !== '5'
      );

      const produtosServico = produtos.filter(
        (produto) =>
          String(produto.ntipoItem) === '5'
      );

      /*
       * Reutiliza a mesma montagem que já funciona
       * no fluxo da NFe.
       *
       * Na NFC-e não fazemos troca de CFOP
       * interestadual neste fluxo.
       */
      const notaProdutos = montarItensNfe({
        produtos: produtosNormais,
        vendaInterestadual: false,
        cfopInterestadual: {
          data: [],
        },
        config,
        buildPIS,
        buildCOFINS,
        buildIBSCBS,
        sanitizeInfAdProd,
        trocarCfop,
      });

      const notaServicos = montarItensNfe({
        produtos: produtosServico,
        vendaInterestadual: false,
        cfopInterestadual: {
          data: [],
        },
        config,
        buildPIS,
        buildCOFINS,
        buildIBSCBS,
        sanitizeInfAdProd,
        trocarCfop,
      });

      temProdutos =
        notaProdutos.detItemArray.length > 0;

      temServicos =
        notaServicos.detItemArray.length > 0;

      if (!temProdutos && !temServicos) {
        throw new Error(
          'Nenhum produto ou serviço válido foi encontrado para emissão.'
        );
      }

      let nomeDoConsumidor = '';

      if (consumidor?.nomeCompleto) {
        nomeDoConsumidor =
          consumidor.nomeCompleto;
      } else if (nomeCupom) {
        nomeDoConsumidor = nomeCupom;
      }

      /*
       * Monta a NFC-e inicialmente com os itens
       * físicos. O pagamento será corrigido depois
       * da separação entre produto e serviço.
       */
      venda = {
        ModeloDocumento: 'NFCe',
        Versao: '4.0',

        ide: {
          cNF: '00000987',

          cUF:
            config.restaurante.endereco
              .cidade.cuf,

          natOp: 'Venda',

          indPag,

          mod: '65',

          serie: config?.serie,

          nNF: '',

          dhEmi: '',

          fusoHorario: '-03:00',

          tpNf: '1',

          idDest: '1',

          indFinal: '1',

          indPres: '1',

          cMunFg:
            config.restaurante.endereco
              .cidade.ibge,

          tpImp: '4',

          tpEmis: '1',

          tpAmb: config.tpAmb,

          finNFe: '1',

          procEmi: '0',
        },

        emit: {
          CNPJ_emit:
            config.restaurante.cnpj,

          xNome:
            config.restaurante.nome,

          IE:
            config.restaurante.ie,

          CRT:
            config.restaurante.crt,

          enderEmit: {
            xLgr:
              config.restaurante.endereco
                .logradouro,

            nro:
              config.restaurante.endereco
                .numero,

            xBairro:
              config.restaurante.endereco
                .bairro,

            cMun:
              config.restaurante.endereco
                .cidade.ibge,

            xMun:
              config.restaurante.endereco
                .cidade.nome,

            UF:
              config.restaurante.endereco
                .cidade.estado,

            CEP:
              config.restaurante.endereco
                .cep,
          },
        },

        dest: {
          CPF_dest:
            config.tpAmb === '2'
              ? '39247350859'
              : documentoCupom
                ? documentoCupom
                : consumidor?.documentoCpfCnpj ||
                '',

          indIEDest:
            documentoCupom ||
              consumidor?.documentoCpfCnpj
              ? '9'
              : '0',

          xNome_dest:
            config.tpAmb === '2'
              ? 'NF-E EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL'
              : documentoCupom ||
                consumidor?.documentoCpfCnpj
                ? nomeDoConsumidor ||
                'Consumidor Identificado'
                : '',

          enderDest: {
            nro_dest:
              consumidor?.endereco?.numero ||
              null,

            xBairro_dest:
              consumidor?.endereco?.bairro ||
              null,

            xEmail_dest:
              emailNota ||
              consumidor?.email ||
              null,

            xLgr_dest:
              consumidor?.endereco
                ?.logradouro ||
              null,

            cMun_dest:
              consumidor?.endereco?.cidade
                ?.ibge ||
              null,

            xMun_dest:
              consumidor?.endereco?.cidade
                ?.nome ||
              null,

            UF_dest:
              consumidor?.endereco
                ?.ufEstado ||
              consumidor?.endereco?.cidade
                ?.estado ||
              null,

            CEP_dest:
              consumidor?.endereco?.cep ||
              null,
          },
        },

        det: {
          detItem:
            notaProdutos.detItemArray,
        },

        total: montarTotalNota(
          notaProdutos.totais
        ),

        transp: parametros?.transp || {
          modFrete: '9',
        },

        pag: {
          pagItem: structuredClone(
            pagItem || []
          ),
        },

        InfoSistema: {
          chaveDocFiscal: '',
          numeroDocFiscal: '',
          serieDocFiscal: '',
        },
      }; if (idPedidoMkt) {
        venda.identificador = idPedidoMkt;
      }

      if (parametros?.NumeroPedido) {
        venda.ide.NumeroPedido =
          parametros.NumeroPedido;
      }

      const telefoneFinal =
        consumidor?.telefone ||
        telefoneEnvio;

      if (telefoneFinal) {
        const telefoneLimpo =
          telefoneFinal.replace(/\D/g, '');

        const telefoneSem55 =
          telefoneLimpo.replace(/^55/, '');

        if (telefoneSem55) {
          venda.dest.enderDest.fone_dest =
            telefoneSem55;
        }
      }

      /*
       * Monta a NFS-e reaproveitando a estrutura
       * principal da venda, mas trocando itens,
       * totais e pagamento.
       */
      vendaServico = temServicos
        ? {
          ...venda,

          ModeloDocumento: 'NFSE',

          det: {
            detItem:
              notaServicos.detItemArray,
          },

          total: montarTotalNota(
            notaServicos.totais
          ),

          pag: {
            pagItem: structuredClone(
              pagItem || []
            ),
          },

          InfoSistema: {
            chaveDocFiscal: '',
            numeroDocFiscal: '',
            serieDocFiscal: '',
            sessao: gerarIdUnico(
              config.restaurante.cnpj
            ),
          },
        }
        : null;

      /*
       * Se existirem produtos e serviços,
       * divide o pagamento entre NFC-e e NFS-e.
       */
      if (temProdutos && temServicos) {
        const pagamentosOriginais = {
          pagItem: structuredClone(
            pagItem || []
          ),
        };

        const valorTotalServico = Number(
          vendaServico.total.ICMStot.vNF
        );

        const valorTotalProduto = Number(
          venda.total.ICMStot.vNF
        );

        const {
          pagServico,
          pagProduto,
        } = separarPagamentos({
          pag: pagamentosOriginais,

          valorServico:
            valorTotalServico,

          valorProduto:
            valorTotalProduto,
        });

        vendaServico.pag = pagServico;
        venda.pag = pagProduto;
      }

      /*
       * Somente produto:
       * pagamento completo fica na NFC-e.
       */
      if (temProdutos && !temServicos) {
        venda.pag = {
          pagItem: structuredClone(
            pagItem || []
          ),
        };
      }

      /*
       * Somente serviço:
       * pagamento completo fica na NFS-e.
       */
      if (!temProdutos && temServicos) {
        vendaServico.pag = {
          pagItem: structuredClone(
            pagItem || []
          ),
        };
      }

      console.log(
        'Venda NFC-e:',
        venda
      );

      console.log(
        'Venda NFS-e:',
        vendaServico
      );

      /*
       * Valida estoque somente dos produtos físicos.
       */
      if (
        temProdutos &&
        config?.terminalComercial
          ?.gerenciaEstoque == true &&
        config?.terminalComercial
          ?.venderZerado == false
      ) {
        try {
          await axios.post(
            `${api.techspdv}/v1/restaurantes/${config.restaurante.id}/produtos/validarEstoque`,

            notaProdutos.detItemArray,

            options
          );
        } catch (errorEstoque) {
          if (
            errorEstoque.response
              ?.status === 400
          ) {
            throw new Error(
              errorEstoque.response.data ||
              'Erro ao validar produtos!'
            );
          }

          throw new Error(
            'Falha na comunicação com o servidor ao validar o estoque.'
          );
        }
      }

      let responseProduto = null;
      let responseServico = null;
      /*
       * 1. Emite e confirma a NFS-e.
       */
      if (temServicos) {
        modeloEmEmissao = 'NFSE';

        setProcessamentoMsg(
          'Emitindo Nota Fiscal de Serviço...'
        );

        responseServico = await axios.post(
          `${api.technfservico}/nfse/gerarnfse`,
          vendaServico,
          options
        );

        /*
         * Guarda imediatamente a NFS-e autorizada.
         * Se a NFC-e falhar depois, teremos a chave
         * necessária para cancelar a NFS-e.
         */
        documentoServicoAutorizado =
          obterDocumentoAutorizado({
            response: responseServico,
            modelo: 'NFSE',
          });

        console.log(
          'NFS-e autorizada:',
          documentoServicoAutorizado
        );
      }

      /*
       * 2. Emite e confirma a NFC-e.
       */
      if (temProdutos) {
        modeloEmEmissao = 'NFCE';

        venda.InfoSistema.sessao =
          gerarIdUnico(
            config.restaurante.cnpj
          );

        setProcessamentoMsg(
          'Aguardando resposta da SEFAZ...'
        );

        responseProduto = await axios.post(
          `${api.technfe}/v1/nota/gerarNota2`,
          venda,
          options
        );

        documentoProdutoAutorizado =
          obterDocumentoAutorizado({
            response: responseProduto,
            modelo: 'NFCE',
          });

        console.log(
          'NFC-e autorizada:',
          documentoProdutoAutorizado
        );
      }



      let notaProdutoOk = !temProdutos;
      let notaServicoOk = !temServicos;

      /*
 * Processa a resposta da NFS-e.
 */
      if (temServicos) {
        notaServicoOk =
          await tratarRespostaNota({
            response: responseServico,
            venda: vendaServico,
            modelo: 'NFSE',
            options,
          });
      }

      /*
       * Processa a resposta da NFC-e.
       */
      if (temProdutos) {
        notaProdutoOk =
          await tratarRespostaNota({
            response: responseProduto,
            venda,
            modelo: 'NFCE',
            options,
          });
      }

      /*
       * Só segue para a finalização se todos os
       * documentos necessários tiverem sido
       * autorizados e gravados.
       */
      if (
        !notaProdutoOk ||
        !notaServicoOk
      ) {
        throw new Error(
          'Um dos documentos fiscais não foi autorizado ou não teve o evento gravado.'
        );
      }

      /*
       * Atualiza os preços somente depois que todos
       * os documentos foram processados com sucesso.
       */
      if (
        config?.terminalComercial
          ?.atualizarProdutoNaVenda
      ) {
        for (const produto of produtos) {
          await axiosInstance.get(
            `${api.techfood}/v1/restaurantes/${config?.idLoja}/produtos/atualizarPreco/${produto?.id}/${Number(
              produto?.preco ?? 0
            ).toFixed(2)}`,

            options
          );
        }
      }

      /*
       * Finaliza o pedido TechsApp apenas uma vez,
       * depois da NFC-e e da NFS-e.
       */
      if (tokenPedidoTechsapp) {
        setProcessamentoMsg(
          'Validando documentos fiscais na Plataforma de Pedidos...'
        );

        const optionsTechsapp = {
          headers: {
            Accept:
              'application/json',

            'Content-Type':
              'application/json',

            Authorization:
              `Basic ${config.restaurante.basic_token}`,
          },
        };

        const bodyConfirmacao = {
          chave_cupom:
            config.restaurante.basic_token,

          numero_cupom:
            config.restaurante.dominio,
        };

        await axios.post(
          `https://www.${config.restaurante.dominio}.com.br/backend/api/pdv/pedido/finalizarPedido/${tokenPedidoTechsapp}`,

          bodyConfirmacao,

          optionsTechsapp
        );
      }

      message.success(
        temProdutos && temServicos
          ? 'NFC-e e NFS-e emitidas com sucesso!'
          : temProdutos
            ? 'NFC-e emitida com sucesso!'
            : 'NFS-e emitida com sucesso!'
      );

      setTokenPedidoTechsapp(null);
      setProcessamentoMsg('');
      setLoading(false);
      setPagItem(null);
      setVendaPuxada(false);
      focarCodigoDeBarras();
      closeModal();
      setProdutos([]);
      setConsumidor(null);
      setNomeCupom('');
      setDocumentoCupom('');
      setConsumidorIdentificado(false);

    } catch (errorEmissao) {
      console.error(
        'Erro ao emitir documentos fiscais:',
        errorEmissao
      );

      const status =
        errorEmissao.response?.status;

      /*
       * Em caso de timeout ou indisponibilidade,
       * tenta recuperar o documento usando a sessão
       * correspondente ao modelo que estava sendo emitido.
       */

      const erroDeSituacaoIncerta =
        errorEmissao.code === 'ECONNABORTED' ||
        status === 502 ||
        status === 503 ||
        status === 504;

      if (erroDeSituacaoIncerta) {
        if (
          modeloEmEmissao === 'NFSE' &&
          vendaServico?.InfoSistema?.sessao
        ) {
          setProcessamentoMsg(
            'Não foi possível confirmar a NFS-e. Tentando recuperar a nota...'
          );

          setTimeout(
            () =>
              validarNota(
                vendaServico,
                'NFSE',
                1,
                null,
                null
              ),
            5000
          );

          return;
        }

        if (
          modeloEmEmissao === 'NFCE' &&
          venda?.InfoSistema?.sessao
        ) {
          setProcessamentoMsg(
            'Não foi possível confirmar a NFC-e. Tentando recuperar a nota...'
          );

          setTimeout(
            () =>
              validarNota(
                venda,
                'NFCE',
                1,
                documentoServicoAutorizado,
                'NFSE'
              ),
            5000
          );

          return;
        }
      }



      /*
 * Se chegou aqui, não é timeout tratado.
 *
 * Caso uma nota tenha sido autorizada e a outra
 * tenha falhado ou sido rejeitada, cancela a
 * primeira automaticamente.
 */
      const documentosParaCancelar = [];

      if (
        temProdutos &&
        temServicos &&
        documentoServicoAutorizado?.docChaAcesso &&
        !documentoProdutoAutorizado
      ) {
        documentosParaCancelar.push({
          modelo: 'NFSE',
          chaveDocFiscal:
            documentoServicoAutorizado.docChaAcesso,
        });
      }

      if (
        temProdutos &&
        temServicos &&
        documentoProdutoAutorizado?.docChaAcesso &&
        !documentoServicoAutorizado
      ) {
        documentosParaCancelar.push({
          modelo: 'NFCE',
          chaveDocFiscal:
            documentoProdutoAutorizado.docChaAcesso,
        });
      }

      if (documentosParaCancelar.length > 0) {
        setProcessamentoMsg(
          'Cancelando o documento autorizado devido à falha da outra nota...'
        );

        const resultadosCancelamento =
          await Promise.allSettled(
            documentosParaCancelar.map(
              ({
                chaveDocFiscal,
                modelo,
              }) =>
                cancelarDocumentoFiscal({
                  chaveDocFiscal,
                  modelo,
                  motivo:
                    'Cancelado pois haviam erros no outro documento fiscal.',
                })
            )
          );

        const cancelamentoComErro =
          resultadosCancelamento.some(
            (resultado) =>
              resultado.status === 'rejected'
          );

        if (cancelamentoComErro) {
          console.error(
            'Falha no cancelamento compensatório:',
            resultadosCancelamento
          );

          window.alert(
            'A segunda nota falhou, mas não foi possível confirmar o cancelamento automático da primeira.\n\n' +
            'Verifique o painel fiscal antes de tentar emitir novamente.'
          );

          setLoading(false);
          setProcessamentoMsg('');
          setMensagemTela('');

          return;
        }

        message.warning(
          'A segunda nota falhou e a primeira foi cancelada automaticamente.'
        );

        documentoProdutoAutorizado = null;
        documentoServicoAutorizado = null;
      }

      const dadosErro =
        errorEmissao.response?.data;

      const detalhe =
        dadosErro?.userMessage ||
        dadosErro?.detail ||
        dadosErro?.error ||
        dadosErro?.message ||
        errorEmissao.message ||
        'Falha na emissão dos documentos fiscais.';

      const mensagemErro =
        typeof detalhe === 'string'
          ? detalhe
          : JSON.stringify(detalhe);

      const continuarVenda = window.confirm(
        `${mensagemErro}\n\n` +
        `Clique em OK para manter a venda aberta e corrigir os dados.\n` +
        `Clique em Cancelar para abandonar e limpar a venda.`
      );

      setLoading(false);
      setProcessamentoMsg('');
      setMensagemTela('');


      if (!continuarVenda) {
        setVendaPuxada(false);
        focarCodigoDeBarras();
        closeModal();
        setProdutos([]);
        setConsumidor(null);
        setNomeCupom('');
        setDocumentoCupom('');
        setConsumidorIdentificado(false);

        setAcresDescFrete({
          acresTotal: '0',
          descTotal: '0',
          frete: '0',
        });
        setPagItem(null);


        return;
      }

    }
  };

  const trocarCfop = (cfop, cfopInterestadual) => {
    const novoCfop = cfopInterestadual.find(p => p.interno === cfop);
    return novoCfop?.externo || cfop;
  };

  function identificarCpfCnpj(valor) {

    if (!valor) return null;

    // remove tudo que não é número
    const str = valor.replace(/\D/g, "");
    console.log(str.length === 14);
    if (str.length === 11) {
      return "CPF";
    } else if (str.length === 14) {
      return "CNPJ";
    } else {
      return "Inválido";
    }
  }



  const toNum = (v) => {
    if (v === null || v === undefined || v === '') return 0;

    const s = String(v).trim().replace(/\s/g, '');
    const norm =
      s.includes(',') && s.includes('.')
        ? s.replace(/\./g, '').replace(',', '.')
        : s.includes(',') && !s.includes('.')
          ? s.replace(',', '.')
          : s;

    const n = Number(norm);
    return Number.isFinite(n) ? n : 0;
  };

  const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

  const montarItensNfe = ({
    produtos = [],
    vendaInterestadual = false,
    cfopInterestadual = { data: [] },
    icmsInterestadual = { data: {} },
    config,
    buildPIS,
    buildCOFINS,
    buildIBSCBS,
    sanitizeInfAdProd,
    trocarCfop,
  }) => {
    const detItemArray = [];

    let vFrete_ttlnfe = 0;
    let Total_vCredICMSSN = 0
    let vDesc_ttlnfe = 0;
    let vOutro_ttlnfe = 0;
    let vProd_ttlnfe = 0;
    let vBC_ttlnfe = 0;
    let vICMS_ttlnfe = 0;
    let vICMSDeson_ttlnfe = 0;
    let qBCMonoRet_ttlnfe = 0;
    let vICMSMonoRet_ttlnfe = 0;

    let vIBSUF_ttnfe = 0;
    let vIBSMun_ttnfe = 0;
    let vCBS_ttnfe = 0;

    for (const produto of produtos) {
      produto.indTot = '1';

      const frete = toNum(produto.frete);
      const valorDesconto = toNum(produto.valorDesconto);
      const valorAcrescimo = toNum(produto.valorAcrescimo);
      const quantidade = toNum(produto.quantidade);
      const preco = toNum(produto.preco);

      vFrete_ttlnfe += frete;
      vDesc_ttlnfe += valorDesconto;
      vOutro_ttlnfe += valorAcrescimo;

      if (produto.indTot === '1') {
        vProd_ttlnfe += round2(quantidade * preco);
      }

      const cst = String(produto.cst);

      let icms = {
        orig: `${produto.origem}`,
        CST: `${produto.cst}`,
        vBC: '0',
      };

      const vBCOriginal = quantidade * preco + valorAcrescimo - valorDesconto;
      if (['00', '10', '20', '30', '70', '90', '900'].includes(cst)) {
        const pRedBCRaw =
          produto.pRedBC ??
          produto.predBc ??
          produto.predbc ??
          produto.pRedBc ??
          0;

        const pRedBC = toNum(pRedBCRaw);


        let vBCFinal = round2(vBCOriginal);

        if (pRedBC > 0 && pRedBC <= 100) {
          icms.pRedBC = round2(pRedBC);
          vBCFinal = round2(vBCOriginal * (1 - pRedBC / 100));
        } else {
          delete icms.pRedBC;
        }

        icms.vBC = round2(vBCFinal);
        icms.modBC = '3';

        // 1. Descobre a alíquota correta
        let aliquotaICMS = toNum(produto.picms);

        if (vendaInterestadual) {
          aliquotaICMS = toNum(
            icmsInterestadual?.data?.aliquota ?? produto.picms
          );
        }

        // 2. Atualiza pICMS
        icms.pICMS = round2(aliquotaICMS);

        // 3. Calcula vICMS com o pICMS novo
        icms.vICMS = round2(
          (icms.pICMS / 100) * icms.vBC
        );

        // 4. Soma nos totais
        vBC_ttlnfe += icms.vBC;
        vICMS_ttlnfe += icms.vICMS;

        const cstComMotDes = new Set(['20', '30', '40', '70', '90', '900']);

        if (cstComMotDes.has(cst)) {
          const icmsSemReducao = round2((icms.pICMS / 100) * vBCOriginal);
          const icmsComReducao = round2((icms.pICMS / 100) * vBCFinal);
          const vICMSDeson = round2(icmsSemReducao - icmsComReducao);

          if (vICMSDeson > 0) {
            icms.vICMSDeson = vICMSDeson;
            icms.motDesICMS = produto.motDesICMS ?? '9';
            vICMSDeson_ttlnfe += vICMSDeson;
          } else {
            delete icms.vICMSDeson;
            delete icms.motDesICMS;
          }
        }
      }

      if (cst == '101' || cst == 101) {

        icms.pCredSN = config?.terminalComercial
          ?.pCredSN101Auto;
        icms.vCredICMSSN = vBCOriginal * (config?.terminalComercial
          ?.pCredSN101Auto / 100);


        Total_vCredICMSSN += icms.vCredICMSSN;


      }
      if (produto.cst == '61' && produto.cfop == '5656') {
        const qBCMonoRet = toNum(produto.weight) * quantidade;
        const adRemICMSRet = toNum(produto.adRemIcmsRet);
        const valor = qBCMonoRet * (adRemICMSRet / 100);
        const vICMSMonoRet = Math.round((valor - Number.EPSILON) * 100) / 100;

        icms.qBCMonoRet = qBCMonoRet;
        icms.adRemICMSRet = adRemICMSRet;
        icms.vICMSMonoRetSemArredondar = valor;
        icms.vICMSMonoRet = vICMSMonoRet;

        qBCMonoRet_ttlnfe += qBCMonoRet;
        vICMSMonoRet_ttlnfe += vICMSMonoRet;
      }

      const pis = buildPIS(produto, icms?.vBC);
      const cofins = buildCOFINS(produto, icms?.vBC);


      const ibsCbsResult = buildIBSCBS(produto, icms?.vBC);

      vIBSUF_ttnfe += ibsCbsResult.totais.vIBSUF;
      vIBSMun_ttnfe += ibsCbsResult.totais.vIBSMun;
      vCBS_ttnfe += ibsCbsResult.totais.vCBS;

      const IBSCBS = ibsCbsResult.IBSCBS;




      console.log(quantidade);
      console.log(preco);
      console.log(quantidade * preco);

      let item = {
        infADProd: sanitizeInfAdProd(produto?.observacao),
        prod: {
          cProd: `${produto.id}`,
          cEAN: `${produto.ean}`,
          xProd:
            config.tpAmb === '2'
              ? 'NOTA FISCAL EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL'
              : `${produto.nome}`,
          NCM: `${produto.ncm}`,
          CFOP: vendaInterestadual
            ? trocarCfop(
              produto.cfop,
              cfopInterestadual?.data ?? []
            )
            : `${produto.cfop}`,
          uCOM: `${produto.unidade}`,
          qCOM: `${produto.quantidade}`,
          vUnCom: `${produto.preco}`,
          vProd: (Math.round(((quantidade * preco) + Number.EPSILON) * 100) / 100).toFixed(2),
          cEANTrib: `${produto.ean ? produto.ean : 'SEM GTIN'}`,
          uTrib: `${produto.unidadeTributavel || produto.unidade}`,
          qTrib: `${produto.quantidade}`,
          vUnTrib: `${produto.preco}`,
          indTot: `${produto.indTot}`,
          nTipoItem: `${produto.ntipoItem}`,
          vFrete: `${frete}`,
          vDesc: `${valorDesconto.toFixed(4)}`,
          CEST: `${produto.cest}`,
          vOutro_item: `${valorAcrescimo.toFixed(2)}`,
          idVendedor: `${produto.idVendedor || ''}`,
          paramServicoAux: {
            discriminacao: produto.descricao || '',
            iteListServico: produto.iteListServico || '',
            tributMunicipio: produto.tributMunicipio || '',
            vAliqISS: produto?.valiqIss || null,
            vISS:
              (Number(quantidade) || 0) *
              (Number(preco) || 0) *
              ((Number(produto?.valiqIss) || 0) / 100) // vProd * (vAliqISS/100)
          },
        },
        imposto: {
          ICMS: icms,
          PIS: pis,
          COFINS: cofins,
          IBSCBS: IBSCBS,
          vTotTrib: '0',
        },
      };




      if (produto.xPed_item && produto.nItemPed) {
        item.prod.xPed_item = produto.xPed_item;
        item.prod.nItemPed = produto.nItemPed;
      }

      if (produto.ntipoItem == '4') {
        if (produto.cprodAnp == '210203001') {
          item.prod.qTrib = toNum(produto.weight) * quantidade;
          item.prod.vUnTrib = preco / toNum(produto.weight);
        }

        item.prod.comb = {
          cProdANP: produto.cprodAnp || '',
          descANP: produto.descAnp || '',
          pGLP: produto.pglp,
          vPart: produto.vpart,
          UFcons: produto.ufConst || '',
        };
      }

      if (produto.cbenef) {
        item.prod.cBenef = produto.cbenef;
      }

      detItemArray.push(item);
    }

    return {
      detItemArray,
      totais: {
        vFrete_ttlnfe: round2(vFrete_ttlnfe),
        vDesc_ttlnfe: round2(vDesc_ttlnfe),
        vOutro_ttlnfe: round2(vOutro_ttlnfe),
        vProd_ttlnfe: round2(vProd_ttlnfe),
        vBC_ttlnfe: round2(vBC_ttlnfe),
        vICMS_ttlnfe: round2(vICMS_ttlnfe),
        vICMSDeson_ttlnfe: round2(vICMSDeson_ttlnfe),
        qBCMonoRet_ttlnfe: round2(qBCMonoRet_ttlnfe),
        vICMSMonoRet_ttlnfe: round2(vICMSMonoRet_ttlnfe),
        vIBSUF_ttnfe: round2(vIBSUF_ttnfe),
        vIBSMun_ttnfe: round2(vIBSMun_ttnfe),
        vCBS_ttnfe: round2(vCBS_ttnfe),
        Total_vCredICMSSN: round2(Total_vCredICMSSN)
      },
    };
  };

  const montarTotalNota = (totais) => ({
    ICMStot: {
      vBC_ttlnfe: totais.vBC_ttlnfe.toFixed(2),
      vICMS_ttlnfe: totais.vICMS_ttlnfe.toFixed(2),
      vICMSDeson_ttlnfe: totais.vICMSDeson_ttlnfe.toFixed(2),
      vBCST_ttlnfe: '0.00',
      vST_ttlnfe: '0.00',
      vProd_ttlnfe: totais.vProd_ttlnfe.toFixed(2),
      vFrete_ttlnfe: totais.vFrete_ttlnfe.toFixed(2),
      vSeg_ttlnfe: '0.00',
      vDesc_ttlnfe: totais.vDesc_ttlnfe.toFixed(2),
      vIPI_ttlnfe: '0.00',
      vPIS_ttlnfe: '0.00',
      vCOFINS_ttlnfe: '0.00',
      vOutro: totais.vOutro_ttlnfe.toFixed(2),
      qBCMonoRet_ttlnfe: totais.qBCMonoRet_ttlnfe.toFixed(2),
      vICMSMonoRet_ttlnfe: totais.vICMSMonoRet_ttlnfe.toFixed(2),
      vNF: (
        round2(totais.vProd_ttlnfe +
          totais.vFrete_ttlnfe -
          totais.vDesc_ttlnfe +
          totais.vOutro_ttlnfe
        )).toFixed(2),
      vTotTrib_ttlnfe: '0.00',
    },

    IBSCBSTot: {
      vBCIBSCBS: totais.vBC_ttlnfe.toFixed(2),
      gIBS: {
        gIBSUF: {
          vDif: '0.00',
          vDevTrib: '0.00',
          vIBSUF: totais.vIBSUF_ttnfe.toFixed(2),
        },
        gIBSMun: {
          vDif: '0.00',
          vDevTrib: '0.00',
          vIBSMun: totais.vIBSMun_ttnfe.toFixed(2),
        },
        vIBS: (totais.vIBSUF_ttnfe + totais.vIBSMun_ttnfe).toFixed(2),
        vCredPres: '0.00',
        vCredPresCondSus: '0.00',
      },
      gCBS: {
        vDif: '0.00',
        vDevTrib: '0.00',
        vCBS: totais.vCBS_ttnfe.toFixed(2),
        vCredPres: '0.00',
        vCredPresCondSus: '0.00',
      },
    },
  });

  const tratarRespostaNota = async ({
    response,
    venda,
    modelo,
    options,
  }) => {
    const doc = response?.data?.documento;

    // A API não retornou o documento
    if (!doc) {
      throw new Error(
        response?.data?.detail ||
        response?.data?.error ||
        response?.data?.message ||
        `Falha ao emitir ${modelo}.`
      );
    }

    // Documento rejeitado
    if (Number(doc.sitCodigo) !== 100) {
      throw new Error(
        doc.sitDescricao ||
        doc.sitMensagem ||
        doc.xMotivo ||
        doc.motivo ||
        doc.message ||
        `Documento rejeitado. Código ${doc.sitCodigo}`
      );
    }

    await sharingPdf(doc.docChaAcesso, modelo);
    downloadXmlViaIframe(doc.docXMLDownload);

    if (idPedidoMkt != "" && config.restaurante.tipoMkt == '3') {
      setProcessamentoMsg('Validando Documentos Fiscais na Plataforma de Pedidos...');

      const nota = await axiosInstance.get(
        `${api.technfe}/v1/historico/chave/${doc.docChaAcesso}`,
        options
      );

      await axios.put(
        `https://apimarket.pedtech.com.br/v1/pedidos/faturar/${idPedidoMkt}/${config?.restaurante?.cnpj}`,
        {
          nfeDate: doc.docDhAut,
          nfeNumber: '' + doc.docNumero,
          nfeSerialNumber: '' + doc.docSerie,
          nfeAccessKey: doc.docChaAcesso,
          xml: nota.data._embedded.historico[0].xmlAutorizado || '',
        },
        { headers: { token: config?.tokenMarketplace } }
      );

      setIdPedidoMkt("");
    }

    if (idPedidoMkt != "" && config.restaurante.tipoMkt == '2') {
      setProcessamentoMsg('Validando Documentos Fiscais na Plataforma de Pedidos...');

      const nota = await axiosInstance.get(
        `${api.technfe}/v1/historico/chave/${doc.docChaAcesso}`,
        options
      );

      await axios.put(
        `https://apimarket.pedtech.com.br/v1/oruc/pedidos/faturar/${idPedidoMkt}/${config?.restaurante?.cnpj}`,
        {
          nfeDate: doc.docDhAut,
          nfeNumber: '' + doc.docNumero,
          nfeSerialNumber: '' + doc.docSerie,
          nfeAccessKey: doc.docChaAcesso,
          xml: nota.data._embedded.historico[0].xmlAutorizado || '',
        },
        { headers: { token: config?.tokenMarketplace } }
      );

      try {
        await axios.put(
          `https://apimarket.pedtech.com.br/v1/oruc/pedidos/separacao/${idPedidoMkt}/${config?.restaurante?.cnpj}`,
          {
            nf_chave: doc.docChaAcesso,
            nfe_numero: '' + doc.docNumero,
            nf_emissao: doc.docDhAut.substring(0, 10),
            xml: nota.data._embedded.historico[0].xmlAutorizado || '',
          },
          { headers: { token: config?.tokenMarketplace } }
        );
      } catch (errorSeparacao) {
        console.warn(
          '⚠️ Separação falhou, mas o processo continua:',
          errorSeparacao.response?.data || errorSeparacao.message
        );
      }

      setIdPedidoMkt("");
    }

    venda.InfoSistema.chaveDocFiscal = doc.docChaAcesso;
    venda.InfoSistema.numeroDocFiscal = doc.docNumero.toString();
    venda.InfoSistema.serieDocFiscal = doc.docSerie.toString();
    venda.InfoSistema.docDhAut = doc.docDhAut;
    //venda.InfoSistema.idVendedorOrcamento = idVendedorOrcamento || '';




    venda.InfoSistema.idVendedorOrcamento =
      habilitarSelecaoVendedor && usuarioSelecionado
        ? usuarioSelecionado
        : idVendedorOrcamento || '';




    venda.InfoSistema.idOrcamento = idOrcamento || '';


    await gravarLog(venda);

    if (telefoneEnvio) {
      const respEnvio = await axios.get(
        `${api.techfood}/v1/envioWhatsapp/enviar/${doc.docChaAcesso}/${config.restaurante.id}/${telefoneEnvio}`,
        options
      );

      console.log(respEnvio.data);
    }
    console.log(sessaoCaixa);
    venda.InfoSistema.sessaoDeCaixa = sessaoCaixa?.id || null;
    const responseEvento = await criarEvento(venda);

    return !!responseEvento?.data;
  };
  const emitirCupomNFE = async () => {



    console.log(parametros);

    setLoading(true);
    setProcessamentoMsg('Emitindo DANFE e Nota Fiscal NFE..');
    let modeloEmEmissao = null;
    let venda = null;
    let vendaServico = null;
    let documentoProdutoAutorizado = null;
    let documentoServicoAutorizado = null;
    let temProdutos = false;
    let temServicos = false;
    try {

      console.log(loja);
      console.log(config.restaurante.endereco.cidade.estado);
      console.log(consumidor?.endereco?.ufEstado);


      let vendaInterestadual = false;

      if (consumidor?.endereco?.ufEstado) {
        vendaInterestadual = consumidor?.endereco?.ufEstado != config.restaurante.endereco.cidade.estado;
      } else {
        vendaInterestadual = consumidor?.endereco?.cidade?.estado != config.restaurante.endereco.cidade.estado;
      }

      console.log(vendaInterestadual);
      console.log(pagItem);
      let icmsInterestadual = {};
      let cfopInterestadual = [];
      if (vendaInterestadual) {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken,
          },
        };

        try {
          icmsInterestadual = await axios.get(
            `${api.techfood}/v1/icms-interestadual/${config.restaurante.endereco.cidade.estado}/${consumidor?.endereco?.ufEstado || consumidor?.endereco?.cidade?.estado}`,
            options,
          )
          console.log(icmsInterestadual.data);
        } catch (error) {

        }


        try {
          cfopInterestadual = await axios.get(
            `${api.techfood}/v1/cfop-interestadual`,
            options,
          );
          console.log(cfopInterestadual.data);
        } catch (error) {
          console.error("Erro ao buscar CFOP:", error);
        }
      }

      console.log('emitirCupom');

      /////////////////////////////////////////////////////////////////////////////////////////////
      const produtosNormais = produtos.filter(
        (produto) => String(produto.ntipoItem) !== '5'
      );

      const produtosServico = produtos.filter(
        (produto) => String(produto.ntipoItem) === '5'
      );

      const notaProdutos = montarItensNfe({
        produtos: produtosNormais,
        vendaInterestadual,
        cfopInterestadual,
        icmsInterestadual,
        config,
        buildPIS,
        buildCOFINS,
        buildIBSCBS,
        sanitizeInfAdProd,
        trocarCfop,
      });

      const notaServicos = montarItensNfe({
        produtos: produtosServico,
        vendaInterestadual,
        cfopInterestadual,
        icmsInterestadual,
        config,
        buildPIS,
        buildCOFINS,
        buildIBSCBS,
        sanitizeInfAdProd,
        trocarCfop,
      });

      const detItemArray = notaProdutos.detItemArray;

      const {
        vBC_ttlnfe,
        vICMS_ttlnfe,
        vFrete_ttlnfe,
        vDesc_ttlnfe,
        vOutro_ttlnfe,
        vProd_ttlnfe,
        qBCMonoRet_ttlnfe,
        vICMSMonoRet_ttlnfe,
        vICMSDeson_ttlnfe,
        vIBSUF_ttnfe,
        vIBSMun_ttnfe,
        vCBS_ttnfe,
      } = notaProdutos.totais;
      //////////////////////////////////////////////////////////////////////////////////////////////

      console.log(vDesc_ttlnfe);
      let nomeDoConsumidor = '';

      if (consumidor?.nomeCompleto) {
        nomeDoConsumidor = consumidor?.nomeCompleto;
      } else {

        if (nomeCupom) {
          nomeDoConsumidor = nomeCupom;
        }
      }

      // 1 Empresa com IE  | 2 empresa sem IE | 9 pessoa fisica
      let indIEDestValidado = '0';
      console.log('indIEDestValidado');
      console.log(documentoCupom);
      console.log(consumidor?.documentoCpfCnpj);
      if (config.tpAmb === '2') {
        indIEDestValidado = '9';
      } else {
        if (identificarCpfCnpj(documentoCupom || consumidor?.documentoCpfCnpj) == 'CPF') {

          indIEDestValidado = '9';
        } else {
          if (identificarCpfCnpj(documentoCupom || consumidor?.documentoCpfCnpj) == 'CNPJ' && (consumidor?.ie || consumidor?.documentoRgIE)) {

            indIEDestValidado = '1';
          } else {
            console.log(identificarCpfCnpj(documentoCupom));
            if (identificarCpfCnpj(documentoCupom || consumidor?.documentoCpfCnpj) == 'CNPJ') {

              indIEDestValidado = '2';
            } else {
              indIEDestValidado = '0';
            }
          }
        }
      }

      console.log(indIEDestValidado);



      venda = {
        ModeloDocumento: 'NFE',
        Versao: '4.0',

        ide: {
          cNF: '00000987',
          cUF: config.restaurante.endereco.cidade.cuf,
          natOp: 'Venda',
          indPag: indPag,
          mod: '55',
          serie: config?.serie,
          nNF: '',
          dhEmi: parametros?.dataEmissao || '',
          fusoHorario: '-03:00',
          tpNf: '1',
          idDest: vendaInterestadual ? '2' : '1',
          indFinal: '1',
          indPres: '1',
          cMunFg: config.restaurante.endereco.cidade.ibge,
          tpImp: '1',
          tpEmis: '1',
          tpAmb: config.tpAmb,
          finNFe: '1',
          procEmi: '0',
        },

        emit: {
          CNPJ_emit: config.restaurante.cnpj,
          xNome: config.restaurante.nome,
          IE: config.restaurante.ie,
          CRT: config.restaurante.crt,
          enderEmit: {
            xLgr: config.restaurante.endereco.logradouro,
            nro: config.restaurante.endereco.numero,
            xBairro: config.restaurante.endereco.bairro,
            cMun: config.restaurante.endereco.cidade.ibge,
            xMun: config.restaurante.endereco.cidade.nome,
            UF: config.restaurante.endereco.cidade.estado,
            CEP: config.restaurante.endereco.cep,
          },
        },

        dest: {
          CPF_dest:
            config.tpAmb === '2'
              ? '39247350859'
              : documentoCupom
                ? documentoCupom
                : consumidor?.documentoCpfCnpj || '',

          indIEDest: indIEDestValidado,

          xNome_dest:
            config.tpAmb === '2'
              ? 'NF-E EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL'
              : documentoCupom || consumidor?.documentoCpfCnpj
                ? nomeDoConsumidor || 'Consumidor Identificado'
                : '',

          enderDest: {
            nro_dest: consumidor?.endereco?.numero || null,
            xBairro_dest: consumidor?.endereco?.bairro || null,
            xEmail_dest: emailNota || consumidor?.email || null,
            xLgr_dest: consumidor?.endereco?.logradouro || null,
            cMun_dest: consumidor?.endereco?.cidade?.ibge || null,
            xMun_dest: consumidor?.endereco?.cidade?.nome || null,
            UF_dest:
              consumidor?.endereco?.ufEstado ||
              consumidor?.endereco?.cidade?.estado ||
              null,
            CEP_dest: consumidor?.endereco?.cep || null,
          },
        },

        det: {
          detItem: notaProdutos.detItemArray,
        },

        total: {
          ICMStot: {
            vBC_ttlnfe: notaProdutos.totais.vBC_ttlnfe.toFixed(2),
            vICMS_ttlnfe: notaProdutos.totais.vICMS_ttlnfe.toFixed(2),
            vICMSDeson_ttlnfe: notaProdutos.totais.vICMSDeson_ttlnfe.toFixed(2),
            vBCST_ttlnfe: '0.00',
            vST_ttlnfe: '0.00',
            vProd_ttlnfe: notaProdutos.totais.vProd_ttlnfe.toFixed(2),
            vFrete_ttlnfe: notaProdutos.totais.vFrete_ttlnfe.toFixed(2),
            vSeg_ttlnfe: '0.00',
            vDesc_ttlnfe: notaProdutos.totais.vDesc_ttlnfe.toFixed(2),
            vIPI_ttlnfe: '0.00',
            vPIS_ttlnfe: '0.00',
            vCOFINS_ttlnfe: '0.00',
            vOutro: notaProdutos.totais.vOutro_ttlnfe.toFixed(2),
            qBCMonoRet_ttlnfe: notaProdutos.totais.qBCMonoRet_ttlnfe.toFixed(2),
            vICMSMonoRet_ttlnfe: notaProdutos.totais.vICMSMonoRet_ttlnfe.toFixed(2),

            vNF: (
              notaProdutos.totais.vProd_ttlnfe +
              notaProdutos.totais.vFrete_ttlnfe -
              notaProdutos.totais.vDesc_ttlnfe +
              notaProdutos.totais.vOutro_ttlnfe
            ).toFixed(2),

            vTotTrib_ttlnfe: '0.00',
          },

          IBSCBSTot: {
            vBCIBSCBS: notaProdutos.totais.vBC_ttlnfe.toFixed(2),

            gIBS: {
              gIBSUF: {
                vDif: '0.00',
                vDevTrib: '0.00',
                vIBSUF: notaProdutos.totais.vIBSUF_ttnfe.toFixed(2),
              },

              gIBSMun: {
                vDif: '0.00',
                vDevTrib: '0.00',
                vIBSMun: notaProdutos.totais.vIBSMun_ttnfe.toFixed(2),
              },

              vIBS: (
                notaProdutos.totais.vIBSUF_ttnfe +
                notaProdutos.totais.vIBSMun_ttnfe
              ).toFixed(2),

              vCredPres: '0.00',
              vCredPresCondSus: '0.00',
            },

            gCBS: {
              vDif: '0.00',
              vDevTrib: '0.00',
              vCBS: notaProdutos.totais.vCBS_ttnfe.toFixed(2),
              vCredPres: '0.00',
              vCredPresCondSus: '0.00',
            },
          },
        },

        transp: parametros?.transp || {
          modFrete: '9',
        },

        pag: {
          pagItem,
        },

        InfoSistema: {
          chaveDocFiscal: '',
          numeroDocFiscal: '',
          serieDocFiscal: '',
        },
      };

      if (idPedidoMkt) {
        venda.identificador = idPedidoMkt;
      }

      if (parametros?.NumeroPedido) {
        venda.ide.NumeroPedido = parametros.NumeroPedido;
      }


      if (mostrarCobranca) {

        const fat = {
          vLiq: parametros?.cobr?.vLiq,
          vDesc: parametros?.cobr?.vDesc,
          vOrig: parametros?.cobr?.vOrig,
          nFat: parametros?.cobr?.nFat,
        }


        const cobr = {
          fat: fat,
        }

        venda.cobr = cobr;


        if (parametros?.cobr?.dup?.dup) {
          venda.cobr.dup = parametros?.cobr?.dup?.dup;
        }

      }


      if (venda.dest.indIEDest == '1') {
        venda.dest.IE_dest = consumidor?.ie || consumidor?.documentoRgIE || null;
      }
      if (parametros.infCpl || config?.terminalComercial
        ?.infoAdicAuto) {
        venda.infAdic = {
          infCpl:
            (config?.terminalComercial?.infoAdicAuto || '') +
            ' ' +
            (parametros.infCpl || ''),
        };

        const substituicoes = {
          '${pCredSN}': Number(config?.terminalComercial?.pCredSN101Auto || 0).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          }) + '% ',
          '${Total_vCredICMSSN}':
            notaProdutos?.totais?.Total_vCredICMSSN?.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }) ?? 'R$ 0,00',
        };

        let infCpl = venda.infAdic.infCpl;

        Object.entries(substituicoes).forEach(([chave, valor]) => {
          infCpl = infCpl.replaceAll(chave, valor ?? '');
        });

        venda.infAdic.infCpl = infCpl;
      }

      const telefoneFinal = consumidor?.telefone || telefoneEnvio;

      if (telefoneFinal) {
        const telefoneLimpo = telefoneFinal.replace(/\D/g, '');
        const telefoneSem55 = telefoneLimpo.replace(/^55/, '');
        if (telefoneSem55) {
          venda.dest.enderDest.fone_dest = telefoneSem55;
        }

      }

      console.log(venda);

      console.log(consumidor);


      temProdutos = notaProdutos.detItemArray.length > 0;
      temServicos = notaServicos.detItemArray.length > 0;

      if (!temProdutos && !temServicos) {
        throw new Error(
          'Nenhum produto ou serviço válido foi encontrado para emissão.'
        );
      }


      vendaServico = temServicos
        ? {
          ...venda,

          ModeloDocumento: 'NFSE',

          det: {
            detItem: notaServicos.detItemArray,
          },

          total: montarTotalNota(notaServicos.totais),

          InfoSistema: {
            chaveDocFiscal: '',
            numeroDocFiscal: '',
            serieDocFiscal: '',
            sessao: gerarIdUnico(config.restaurante.cnpj),
          },
        }
        : null;

      if (config?.terminalComercial?.gerenciaEstoque == true && config?.terminalComercial?.venderZerado == false) {
        const options = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken,
          },
        };

        try {
          const validarProdutos = await axios.post(
            `${api.techspdv}/v1/restaurantes/${config.restaurante.id}/produtos/validarEstoque`,
            detItemArray,
            options
          );
          console.log(validarProdutos);
        } catch (error) {


          // Verifica se a resposta tem um status 400 e trata adequadamente
          if (error.response?.status === 400) {
            console.error(error.response.data || "Erro ao validar produtos!");
            message.error(error.response.data || "Erro ao validar produtos!");
            setLoading(false);
            return;
          } else {
            console.error("Falha na comunicação com o servidor!");
            message.error("Falha na comunicação com o servidor!");
            setLoading(false);
            return;
          }
        }
      }

      console.log('após o if');
      // await gravarLog(venda);
      //    return;

      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };


      let responseProduto = null;
      let responseServico = null;
      const pagamentosOriginais = structuredClone(venda.pag);

      const valorTotalServico = Number(
        vendaServico?.total?.ICMStot?.vNF || 0
      );

      const valorTotalProduto = Number(
        venda?.total?.ICMStot?.vNF
      );

      const {
        pagServico,
        pagProduto
      } = separarPagamentos({
        pag: pagamentosOriginais,
        valorServico: valorTotalServico,
        valorProduto: valorTotalProduto,
      });

      if (vendaServico) {
        vendaServico.pag = pagServico;
      }

      if (venda) {
        venda.pag = pagProduto;
      }


      console.log("Serviço:", vendaServico?.pag);
      console.log("Produto:", venda?.pag);

      console.log(venda);
      console.log(vendaServico);


      /*
     * 1. Emite e confirma a NFS-e.
     */
      if (temServicos) {
        modeloEmEmissao = 'NFSE';

        setProcessamentoMsg(
          'Emitindo Nota Fiscal de Serviço...'
        );

        responseServico = await axios.post(
          `${api.technfservico}/nfse/gerarnfse`,
          vendaServico,
          options
        );

        /*
         * Guarda imediatamente o documento autorizado.
         *
         * Assim, se a NF-e falhar depois,
         * o catch saberá qual NFS-e cancelar.
         */
        documentoServicoAutorizado =
          obterDocumentoAutorizado({
            response: responseServico,
            modelo: 'NFSE',
          });

        console.log(
          'NFS-e autorizada:',
          documentoServicoAutorizado
        );
      }

      /*
       * 2. Emite e confirma a NF-e.
       */
      if (temProdutos) {

        modeloEmEmissao = 'NFE';

        venda.InfoSistema.sessao =
          gerarIdUnico(config.restaurante.cnpj);

        setProcessamentoMsg(
          'Aguardando resposta da SEFAZ...'
        );

        responseProduto = await axios.post(
          `${api.technfe}/v1/nota/gerarNota2`,
          venda,
          options
        );

        documentoProdutoAutorizado =
          obterDocumentoAutorizado({
            response: responseProduto,
            modelo: 'NFE',
          });

        console.log(
          'NF-e autorizada:',
          documentoProdutoAutorizado
        );
      }

      let notaProdutoOk = !temProdutos;
      let notaServicoOk = !temServicos;

      if (temServicos) {
        notaServicoOk = await tratarRespostaNota({
          response: responseServico,
          venda: vendaServico,
          modelo: 'NFSE',
          options,
        });
      }

      if (temProdutos) {
        notaProdutoOk = await tratarRespostaNota({
          response: responseProduto,
          venda,
          modelo: 'NFE',
          options,
        });
      }

      if (!notaProdutoOk || !notaServicoOk) {
        throw new Error(
          'Um dos documentos fiscais não foi autorizado ou não teve o evento gravado.'
        );
      }

      message.success(
        temProdutos && temServicos
          ? 'NF-e e NFS-e emitidas com sucesso!'
          : temProdutos
            ? 'NF-e emitida com sucesso!'
            : 'NFS-e emitida com sucesso!'
      );

      setTokenPedidoTechsapp(null);
      setProcessamentoMsg('');
      setMensagemTela('');
      setVendaPuxada(false);
      setLoading(false);
      focarCodigoDeBarras();
      closeModal();

      setProdutos([]);
      setConsumidor(null);
      setNomeCupom('');
      setDocumentoCupom('');
      setConsumidorIdentificado(false);

      setPagamentos([]);
      setPagItem([]);
      setPagamentoConcluido(false);

      setAcresDescFrete({
        acresTotal: '0',
        descTotal: '0',
        frete: '0',
      });

      setAcresDescFreteConcluido(false);
      setAcrescimoDescontosFreteConcluido(false);
      setPagItem(null);

    } catch (errorEmissao) {
      console.error(
        'Erro ao emitir documentos fiscais:',
        errorEmissao
      );

      const status =
        errorEmissao.response?.status;

      const erroDeSituacaoIncerta =
        errorEmissao.code === 'ECONNABORTED' ||
        status === 502 ||
        status === 503 ||
        status === 504;

      if (erroDeSituacaoIncerta) {
        /*
         * Timeout na emissão da NFS-e.
         * Como ela é emitida primeiro, não existe
         * documento anterior para cancelar.
         */
        if (
          modeloEmEmissao === 'NFSE' &&
          vendaServico?.InfoSistema?.sessao
        ) {
          setProcessamentoMsg(
            'Não foi possível confirmar a NFS-e. Tentando recuperar a nota...'
          );

          setTimeout(
            () =>
              validarNota(
                vendaServico,
                'NFSE',
                1,
                null,
                null
              ),
            5000
          );

          return;
        }

        /*
         * Timeout na emissão da NF-e.
         * Se ela não for recuperada, a NFS-e
         * autorizada anteriormente será cancelada.
         */
        if (
          modeloEmEmissao === 'NFE' &&
          venda?.InfoSistema?.sessao
        ) {
          setProcessamentoMsg(
            'Não foi possível confirmar a NF-e. Tentando recuperar a nota...'
          );

          setTimeout(
            () =>
              validarNota(
                venda,
                'NFE',
                1,
                documentoServicoAutorizado,
                'NFSE'
              ),
            5000
          );

          return;
        }
      }

      if (!erroDeSituacaoIncerta) {
        const documentosParaCancelar = [];

        if (
          temProdutos &&
          temServicos &&
          documentoServicoAutorizado?.docChaAcesso &&
          !documentoProdutoAutorizado
        ) {
          documentosParaCancelar.push({
            modelo: 'NFSE',
            chaveDocFiscal:
              documentoServicoAutorizado.docChaAcesso,
          });
        }

        if (
          temProdutos &&
          temServicos &&
          documentoProdutoAutorizado?.docChaAcesso &&
          !documentoServicoAutorizado
        ) {
          documentosParaCancelar.push({
            modelo: 'NFE',
            chaveDocFiscal:
              documentoProdutoAutorizado.docChaAcesso,
          });
        }

        if (documentosParaCancelar.length > 0) {
          setProcessamentoMsg(
            'Cancelando documento autorizado...'
          );

          const resultados =
            await Promise.allSettled(
              documentosParaCancelar.map(
                ({ chaveDocFiscal, modelo }) =>
                  cancelarDocumentoFiscal({
                    chaveDocFiscal,
                    modelo,
                    motivo:
                      'Cancelado pois haviam erros no outro documento fiscal.',
                  })
              )
            );

          const houveErro =
            resultados.some(
              (resultado) =>
                resultado.status === 'rejected'
            );

          if (houveErro) {
            console.error(
              'Falha no cancelamento:',
              resultados
            );

            window.alert(
              'Não foi possível confirmar o cancelamento automático da primeira nota. Verifique o painel fiscal.'
            );

            setLoading(false);
            setProcessamentoMsg('');

            return;
          }

          message.warning(
            'A segunda nota falhou e a primeira foi cancelada automaticamente.'
          );
        }
      }

      const dadosErro =
        errorEmissao.response?.data;

      const detalhe =
        dadosErro?.userMessage ||
        dadosErro?.detail ||
        dadosErro?.error ||
        dadosErro?.message ||
        errorEmissao.message ||
        'Falha na emissão dos documentos fiscais.';

      const mensagemErro =
        typeof detalhe === 'string'
          ? detalhe
          : JSON.stringify(detalhe);


      const continuarVenda = window.confirm(
        `${mensagemErro}\n\n` +
        `Clique em OK para manter a venda aberta e corrigir os dados.\n` +
        `Clique em Cancelar para abandonar e limpar a venda.`
      );

      setLoading(false);
      setProcessamentoMsg('');
      setMensagemTela('');

      if (!continuarVenda) {
        setVendaPuxada(false);
        focarCodigoDeBarras();
        closeModal();

        setProdutos([]);
        setConsumidor(null);
        setNomeCupom('');
        setDocumentoCupom('');
        setConsumidorIdentificado(false);

        setAcresDescFrete({
          acresTotal: '0',
          descTotal: '0',
          frete: '0',
        });
        setPagItem(null);

        return;
      }
    }
  };

  const CardNotaFiscal = ({
    icone,
    titulo,
    subtotal,
    descontos,
    acrescimos,
    frete,
    total,
    mostrarFrete = true,
  }) => (
    <div style={estiloCardFinanceiro}>
      <div style={estiloTituloCardFinanceiro}>
        <span>{icone}</span>
        <span>{titulo}</span>
      </div>

      <div style={estiloGridFinanceiro}>
        <div style={estiloItemFinanceiro}>
          <span style={estiloLabelResumo}>Subtotal</span>
          <strong style={estiloValorResumo}>
            {formatarMoeda(subtotal)}
          </strong>
        </div>

        <div style={estiloItemFinanceiro}>
          <span style={estiloLabelResumo}>Descontos</span>
          <strong style={estiloValorResumo}>
            {formatarMoeda(descontos)}
          </strong>
        </div>

        <div style={estiloItemFinanceiro}>
          <span style={estiloLabelResumo}>Acréscimos</span>
          <strong style={estiloValorResumo}>
            {formatarMoeda(acrescimos)}
          </strong>
        </div>

        {mostrarFrete && (
          <div style={estiloItemFinanceiro}>
            <span style={estiloLabelResumo}>Frete</span>
            <strong style={estiloValorResumo}>
              {formatarMoeda(frete)}
            </strong>
          </div>
        )}
      </div>

      <div style={estiloTotalFinanceiro}>
        <span style={estiloLabelTotalFinanceiro}>Total</span>

        <strong style={estiloValorTotalFinanceiro}>
          {formatarMoeda(total)}
        </strong>
      </div>
    </div>
  );
  const formatarMoeda = (valor) => {
    return Number(valor || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };
  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };
      axios
        .get(
          `${api.techfood}/v1/restaurantes/usuario/${idUser}`,
          options,
        )
        .then(async restaurante => {
          setLoja(restaurante.data);
        });
    }
  }, [idUser, accessToken]);

  const getDataAtual = () => {
    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const ano = dataAtual.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const formatarDocumento = documento => {
    const documentoSemMascara = documento.replace(/\D/g, ''); // Remove caracteres não numéricos
    if (documentoSemMascara.length === 11) {
      // Se o documento tem 11 dígitos, é um CPF
      return documentoSemMascara.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        '$1.$2.$3-$4',
      ); // Formato: XXX.XXX.XXX-XX
    } else if (documentoSemMascara.length === 14) {
      // Se o documento tem 14 dígitos, é um CNPJ
      return documentoSemMascara.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5',
      ); // Formato: XX.XXX.XXX/XXXX-XX
    } else {
      // Caso contrário, retorna o documento original
      return documento;
    }
  };

  return (
    <div className="container">
      <header className="modal-header">
        <Button
          type="primary"
          onClick={() => { closeModal(); focarCodigoDeBarras(); }}
          style={{ backgroundColor: "black", borderColor: "black" }}
        >
          <span>Voltar para Venda</span>
        </Button>
        <h1>Finalizar Venda</h1>
      </header>
      {
        isModalVisibleConsumidor ? (

          <IdentificarConsumidor
            onClose={toggleModalIdentificarConsumidor}
            isVisible={isModalVisibleConsumidor}
            nomeDoCupom={setNomeCupom}
            documentoDoCupom={setDocumentoCupom}
            setConsumidorIdentificado={setConsumidorIdentificado}
            consumidorIdentificado={consumidorIdentificado}
            consumidor={consumidor}
            setConsumidor={setConsumidor}
            documentoIntegracao={documentoCupom}
            emailNota={emailNota}
            setEmailNota={setEmailNota}
            telefoneEnvio={telefoneEnvio}
            setTelefoneEnvio={setTelefoneEnvio}

          ></IdentificarConsumidor>

        ) :
          isModalVisiblePagamento ? (
            <PaymentScreen onClose={toggleModalPagamento}
              isVisible={isModalVisiblePagamento}
              precoTotal={precoTotal.toFixed(2)}
              setPagamentoConcluido={setPagamentoConcluido}
              setPagItem={setPagItem}
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              idLoja={config.restaurante.id}
              formasDePagamento={formasDePagamento}
              totalPago={totalPago}
              setTotalPago={setTotalPago}
            ></PaymentScreen>
          ) : isModalVisibleParametros ? (<Parametros
            onClose={toggleModalParametros}
            isVisible={isModalVisibleParametros}
            precoTotal={precoTotal}
            setPagamentoConcluido={setPagamentoConcluido}
            setPagItem={setPagItem}
            pagamentos={pagamentos}
            setPagamentos={setPagamentos}
            setIndPag={setIndPag}
            indPag={indPag}
            parametros={parametros}
            setParametros={setParametros}
            mostrarCobranca={mostrarCobranca}
            setMostrarCobranca={setMostrarCobranca}
            fatura={fatura}
            setFatura={setFatura}
            infCpl={infCpl}
            setInfCpl={setInfCpl}
          >

          </Parametros>) :


            isModalVisibleAcresDesc ? (<AcrescimoDescontoTotal
              onClose={toggleModalAcresDesc}
              isVisible={isModalVisibleAcresDesc}
              precoTotal={precoTotal}
              setPagamentoConcluido={setPagamentoConcluido}
              setPagItem={setPagItem}
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              acresDescFrete={acresDescFrete}
              setAcresDescFrete={setAcresDescFrete}
              produtos={produtos}
              setProdutos={setProdutos}
              CalcularTotais={CalcularTotais}
              subTotal={subTotal}
              setAcrescimoDescontosFreteConcluido={
                setAcrescimoDescontosFreteConcluido
              }></AcrescimoDescontoTotal>) :
              (
                loading ? (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40, width: '100%' }}>
                    <Spin
                      spinning={loading}
                      tip={<span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>Carregando...</span>}
                      size="large"
                    />
                    {processamentoMsg && (
                      <span style={{ marginTop: 16, fontSize: 20, color: '#666' }}>{processamentoMsg}</span>
                    )}
                  </div>
                ) :
                  (<>
                    {/*<div className="container-buttons">

                      <div className="row">
                        <button
                          className={`button ${consumidorIdentificado || documentoCupom ? 'button-success' : 'button-purple'}`}
                          onClick={toggleModalIdentificarConsumidor}
                        >
                          Identificar Consumidor
                        </button>
                      </div>


                      <div className="row">
                        <button className="button button-warning" onClick={() => { if (!travarAcrescimoDescFrete) { toggleModalAcresDesc() } }}>
                          Acréscimos e Descontos
                        </button>
                      </div>

                      <div className="row">
                        <button className="button button-dark" onClick={toggleModalPagamento}>
                          Pagamento
                        </button>
                      </div>
                      <div className="row">
                        <button className="button button-primary" onClick={toggleModalParametros}>
                          Parâmetros
                        </button>
                      </div>
                      <div className="row">
                        <button
                          className={`button ${!pagamentoConcluido || loading || (consumidor && (consumidor?.endereco?.ufEstado != loja?.endereco?.cidade?.estado && consumidor?.endereco?.ufEstado != null)) ? 'button-disabled' : 'button-success'}`}
                          onClick={emitirCupom}
                          disabled={!pagamentoConcluido || loading || (consumidor && (consumidor?.endereco?.ufEstado != loja?.endereco?.cidade?.estado && consumidor?.endereco?.ufEstado != null))}
                        >
                          {'Emitir Cupom'}
                        </button>
                      </div>

                      <div className="row">
                        <button
                          className={`button ${pagamentoConcluido && !loading && consumidor?.endereco ? 'button-success' : 'button-disabled'}`}
                          onClick={emitirCupomNFE}
                          disabled={!pagamentoConcluido || loading || !consumidor?.endereco}
                        >
                          {'Emitir Danfe'}
                        </button>
                      </div>
                    </div>*/}

                    <div style={estiloContainerButtons}>
                      {/* Linha 1 */}
                      <div style={estiloButtonsRow}>
                        <button
                          style={{
                            ...estiloBotao,
                            background:
                              consumidorIdentificado || documentoCupom
                                ? 'linear-gradient(135deg, #22c55e, #15803d)'
                                : 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
                          }}
                          onClick={toggleModalIdentificarConsumidor}
                        >
                          <span style={estiloIconeBotao}>👤</span>

                          <span style={estiloConteudoBotao}>
                            <span style={estiloTituloBotao}>
                              Identificar Consumidor
                            </span>

                            <span style={estiloDescricaoBotao}>
                              CPF, CNPJ e dados do cliente
                            </span>
                          </span>
                        </button>

                        <button
                          style={{
                            ...estiloBotao,
                            background: travarAcrescimoDescFrete
                              ? 'linear-gradient(135deg, #b8b8b8, #909090)'
                              : 'linear-gradient(135deg, #f59e0b, #ea580c)',
                            cursor: travarAcrescimoDescFrete
                              ? 'not-allowed'
                              : 'pointer',
                            opacity: travarAcrescimoDescFrete ? 0.65 : 1,
                          }}
                          onClick={() => {
                            if (!travarAcrescimoDescFrete) {
                              toggleModalAcresDesc();
                            }
                          }}
                          disabled={travarAcrescimoDescFrete}
                        >
                          <span style={estiloIconeBotao}>％</span>

                          <span style={estiloConteudoBotao}>
                            <span style={estiloTituloBotao}>
                              Acréscimos e Descontos
                            </span>

                            <span style={estiloDescricaoBotao}>
                              Ajuste os valores da venda
                            </span>
                          </span>
                        </button>
                      </div>

                      {/* Linha 2 */}
                      <div style={estiloButtonsRow}>
                        <button
                          style={{
                            ...estiloBotao,
                            background: possuiPagamento
                              ? 'linear-gradient(135deg,#22C55E,#15803D)'
                              : 'linear-gradient(135deg,#374151,#111827)',
                          }}
                          onClick={toggleModalPagamento}
                        >
                          <span style={estiloIconeBotao}>
                            💳
                          </span>

                          <span style={estiloConteudoBotao}>
                            <span style={estiloTituloBotao}>
                              Pagamento
                            </span>

                            <span style={estiloDescricaoBotao}>
                              {obterResumoPagamentos()}
                            </span>
                          </span>
                        </button>

                        <button
                          style={{
                            ...estiloBotao,
                            background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
                          }}
                          onClick={toggleModalParametros}
                        >
                          <span style={estiloIconeBotao}>⚙</span>

                          <span style={estiloConteudoBotao}>
                            <span style={estiloTituloBotao}>
                              Parâmetros
                            </span>

                            <span style={estiloDescricaoBotao}>
                              Configurações da emissão
                            </span>
                          </span>
                        </button>
                      </div>

                      {/* Usuário responsável pela venda */}
                      {habilitarSelecaoVendedor && (
                        <div
                          style={{
                            width: '100%',
                            marginTop: '12px',
                            marginBottom: '12px',
                          }}
                        >
                          <div
                            style={{
                              marginBottom: '6px',
                              fontSize: '14px',
                              fontWeight: '600',
                              color: '#374151',
                            }}
                          >
                            👤 Usuário responsável pela venda
                          </div>

                          <Select
                            showSearch
                            allowClear
                            loading={loadingUsuarios}
                            placeholder="Selecione o usuário responsável pela venda"
                            value={usuarioSelecionado}
                            onChange={(value) => setUsuarioSelecionado(value)}
                            optionFilterProp="label"
                            style={{
                              width: '100%',
                            }}
                            options={usuarios.map((usuario) => ({
                              value: usuario.id,
                              label: usuario.nome,
                            }))}
                          />
                        </div>
                      )}

                      {/* Linha 3 */}
                      <div style={estiloButtonsRow}>
                        <button
                          style={{
                            ...estiloBotao,
                            background:
                              !pagamentoConcluido ||
                                loading ||
                                (consumidor &&
                                  consumidor?.endereco?.ufEstado !==
                                  loja?.endereco?.cidade?.estado &&
                                  consumidor?.endereco?.ufEstado != null)
                                ? 'linear-gradient(135deg, #b8b8b8, #909090)'
                                : 'linear-gradient(135deg, #22c55e, #15803d)',

                            cursor:
                              !pagamentoConcluido ||
                                loading ||
                                (consumidor &&
                                  consumidor?.endereco?.ufEstado !==
                                  loja?.endereco?.cidade?.estado &&
                                  consumidor?.endereco?.ufEstado != null)
                                ? 'not-allowed'
                                : 'pointer',

                            opacity:
                              !pagamentoConcluido ||
                                loading ||
                                (consumidor &&
                                  consumidor?.endereco?.ufEstado !==
                                  loja?.endereco?.cidade?.estado &&
                                  consumidor?.endereco?.ufEstado != null)
                                ? 0.65
                                : 1,
                          }}
                          onClick={emitirCupom}
                          disabled={
                            !pagamentoConcluido ||
                            loading ||
                            (consumidor &&
                              consumidor?.endereco?.ufEstado !==
                              loja?.endereco?.cidade?.estado &&
                              consumidor?.endereco?.ufEstado != null)
                          }
                        >
                          <span style={estiloIconeBotao}>🧾</span>

                          <span style={estiloConteudoBotao}>
                            <span style={estiloTituloBotao}>
                              Emitir Cupom
                            </span>

                            <span style={estiloDescricaoBotao}>
                              Finalizar com NFC-e
                            </span>
                          </span>
                        </button>

                        <button
                          style={{
                            ...estiloBotao,
                            background:
                              !pagamentoConcluido ||
                                loading ||
                                !consumidor?.endereco
                                ? 'linear-gradient(135deg, #b8b8b8, #909090)'
                                : 'linear-gradient(135deg, #10b981, #047857)',

                            cursor:
                              !pagamentoConcluido ||
                                loading ||
                                !consumidor?.endereco
                                ? 'not-allowed'
                                : 'pointer',

                            opacity:
                              !pagamentoConcluido ||
                                loading ||
                                !consumidor?.endereco
                                ? 0.65
                                : 1,
                          }}
                          onClick={emitirCupomNFE}
                          disabled={
                            !pagamentoConcluido ||
                            loading ||
                            !consumidor?.endereco
                          }
                        >
                          <span style={estiloIconeBotao}>📄</span>

                          <span style={estiloConteudoBotao}>
                            <span style={estiloTituloBotao}>
                              Emitir Danfe
                            </span>

                            <span style={estiloDescricaoBotao}>
                              Finalizar com NF-e
                            </span>
                          </span>
                        </button>
                      </div>
                    </div>

                    {/*<div className="card_totais" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
         
                      <div>
                        <p style={estiloP}>{getDataAtual()}</p>
                        <p style={estiloP}>Documento: {documentoCupom ? formatarDocumento(documentoCupom) : consumidor?.documentoCpfCnpj ? formatarDocumento(consumidor?.documentoCpfCnpj) : ''}</p>
                        <p style={estiloP}>E-mail de Envio: {consumidor?.email || emailNota || ''}</p>
                        <p style={estiloP}>Telefone de Envio: {telefoneEnvio ? formatarTelefone(telefoneEnvio) : ''}</p>
                        <p style={estiloP}>Subtotal: {subTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        <p style={estiloP}>Desconto: {totalDescontos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        <p style={estiloP}>Acréscimos: {totalAcrescimos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        <p style={estiloP}>Frete: {parseFloat(acresDescFrete.frete).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        <p style={estiloP}>Total: {precoTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>


                        {parametros?.infCpl && (<p style={estiloObservacao}>Observação da Danfe: {parametros?.infCpl}</p>)}
                      </div>

               
                      {consumidor && (
                        <div>
                          {consumidor?.endereco?.numero && <p style={estiloP}>Número: {consumidor.endereco.numero}</p>}
                          {consumidor?.endereco?.bairro && <p style={estiloP}>Bairro: {consumidor.endereco.bairro}</p>}
                          {consumidor?.endereco?.logradouro && <p style={estiloP}>Logradouro: {consumidor.endereco.logradouro}</p>}
                          {consumidor?.endereco?.cidade?.ibge && <p style={estiloP}>IBGE: {consumidor.endereco.cidade.ibge}</p>}
                          {consumidor?.endereco?.cidade?.nome && <p style={estiloP}>Cidade: {consumidor.endereco.cidade.nome}</p>}
                          {consumidor?.endereco?.ufEstado || consumidor?.endereco?.cidade?.estado && <p style={estiloP}>UF: {consumidor.endereco.ufEstado || consumidor?.endereco?.cidade?.estado}</p>}
                          {consumidor?.ie || consumidor?.documentoRgIE && <p style={estiloP}>Inscrição Estadual: : {consumidor?.ie || consumidor?.documentoRgIE}</p>}
                          {consumidor?.telefone && <p style={estiloP}>Telefone Cadastrado: {consumidor.telefone}</p>}
                          {consumidor?.email && <p style={estiloP}>E-mail Cadastrado: {consumidor?.email}</p>}

                        </div>
                      )}

                    </div>*/}














                    <div style={estiloGridResumoVenda}>
                      {/* Área esquerda */}
                      <div style={estiloAreaResumoVenda}>
                        {/* Data, e-mail e telefone */}
                        <div style={estiloGridCabecalho}>
                          <div style={estiloCardPequeno}>
                            <span style={estiloLabelResumo}>Data</span>
                            <strong style={estiloValorResumo}>
                              {getDataAtual()}
                            </strong>
                          </div>

                          <div style={estiloCardPequeno}>
                            <span style={estiloLabelResumo}>E-mail de envio</span>
                            <strong style={estiloValorResumo}>
                              {consumidor?.email || emailNota || 'Não informado'}
                            </strong>
                          </div>

                          <div style={estiloCardPequeno}>
                            <span style={estiloLabelResumo}>Telefone de envio</span>
                            <strong style={estiloValorResumo}>
                              {telefoneEnvio
                                ? formatarTelefone(telefoneEnvio)
                                : 'Não informado'}
                            </strong>
                          </div>
                        </div>

                        {/* Totais gerais da venda */}
                        <div style={estiloGridTotaisVenda}>
                          <div style={estiloCardPequeno}>
                            <span style={estiloLabelResumo}>Subtotal da venda</span>
                            <strong style={estiloValorResumo}>
                              {formatarMoeda(subTotal)}
                            </strong>
                          </div>

                          <div style={estiloCardPequeno}>
                            <span style={estiloLabelResumo}>Desconto da venda</span>
                            <strong style={estiloValorResumo}>
                              {formatarMoeda(totalDescontos)}
                            </strong>
                          </div>

                          <div style={estiloCardPequeno}>
                            <span style={estiloLabelResumo}>Total da venda</span>
                            <strong
                              style={{
                                ...estiloValorResumo,
                                color: '#16a34a',
                                fontSize: '19px',
                              }}
                            >
                              {formatarMoeda(precoTotal)}
                            </strong>
                          </div>
                        </div>

                        {/* Produtos */}
                        <CardNotaFiscal
                          icone="📦"
                          titulo="Nota Fiscal de Produtos"
                          subtotal={subTotalProdutos}
                          descontos={totalDescontosProdutos}
                          acrescimos={totalAcrescimosProdutos}
                          frete={freteProdutos}
                          total={totalProdutos}
                        />

                        {/* Serviços */}
                        <CardNotaFiscal
                          icone="🛠️"
                          titulo="Nota Fiscal de Serviços"
                          subtotal={subTotalServicos}
                          descontos={totalDescontosServicos}
                          acrescimos={totalAcrescimosServicos}
                          total={totalServicos}
                          mostrarFrete={false}
                        />

                        {parametros?.infCpl && (
                          <div style={estiloCardFinanceiro}>
                            <div style={estiloTituloCardFinanceiro}>
                              <span>📝</span>
                              <span>Observação da DANFE</span>
                            </div>

                            <p style={estiloObservacao}>
                              {parametros.infCpl}
                            </p>
                          </div>
                        )}
                      </div>

                      {/* Área direita */}
                      <div style={estiloCardConsumidor}>
                        <div style={estiloTituloConsumidor}>
                          <span>👤</span>
                          <span>Dados do Cliente</span>
                        </div>

                        <div style={estiloLinhaConsumidor}>
                          <span style={estiloLabelResumo}>Nome</span>
                          <span style={estiloValorConsumidor}>
                            {consumidor?.nome ||
                              consumidor?.razaoSocial || consumidor?.nomeCompleto ||
                              'Não informado'}
                          </span>
                        </div>

                        <div style={estiloLinhaConsumidor}>
                          <span style={estiloLabelResumo}>CPF/CNPJ</span>
                          <span style={estiloValorConsumidor}>
                            {documentoCupom
                              ? formatarDocumento(documentoCupom)
                              : consumidor?.documentoCpfCnpj
                                ? formatarDocumento(consumidor.documentoCpfCnpj)
                                : 'Não informado'}
                          </span>
                        </div>

                        {(consumidor?.ie || consumidor?.documentoRgIE) && (
                          <div style={estiloLinhaConsumidor}>
                            <span style={estiloLabelResumo}>IE/RG</span>
                            <span style={estiloValorConsumidor}>
                              {consumidor?.ie || consumidor?.documentoRgIE}
                            </span>
                          </div>
                        )}

                        {consumidor?.endereco?.logradouro && (
                          <div style={estiloLinhaConsumidor}>
                            <span style={estiloLabelResumo}>Logradouro</span>
                            <span style={estiloValorConsumidor}>
                              {consumidor.endereco.logradouro}
                            </span>
                          </div>
                        )}

                        {consumidor?.endereco?.numero && (
                          <div style={estiloLinhaConsumidor}>
                            <span style={estiloLabelResumo}>Número</span>
                            <span style={estiloValorConsumidor}>
                              {consumidor.endereco.numero} {consumidor.endereco.complemento}
                            </span>
                          </div>
                        )}

                        {consumidor?.endereco?.bairro && (
                          <div style={estiloLinhaConsumidor}>
                            <span style={estiloLabelResumo}>Bairro</span>
                            <span style={estiloValorConsumidor}>
                              {consumidor.endereco.bairro}
                            </span>
                          </div>
                        )}

                        {consumidor?.endereco?.cidade?.nome && (
                          <div style={estiloLinhaConsumidor}>
                            <span style={estiloLabelResumo}>Cidade</span>
                            <span style={estiloValorConsumidor}>
                              {consumidor.endereco.cidade.nome}   {consumidor?.endereco?.cidade?.ibge}
                            </span>
                          </div>
                        )}

                        {(consumidor?.endereco?.ufEstado ||
                          consumidor?.endereco?.cidade?.estado) && (
                            <div style={estiloLinhaConsumidor}>
                              <span style={estiloLabelResumo}>Estado</span>
                              <span style={estiloValorConsumidor}>
                                {consumidor?.endereco?.ufEstado ||
                                  consumidor?.endereco?.cidade?.estado}
                              </span>
                            </div>
                          )}

                        {consumidor?.endereco?.cep && (
                          <div style={estiloLinhaConsumidor}>
                            <span style={estiloLabelResumo}>CEP</span>
                            <span style={estiloValorConsumidor}>
                              {consumidor.endereco.cep}
                            </span>
                          </div>
                        )}

                        {consumidor?.telefone && (
                          <div style={estiloLinhaConsumidor}>
                            <span style={estiloLabelResumo}>Telefone</span>
                            <span style={estiloValorConsumidor}>
                              {formatarTelefone(consumidor.telefone)}
                            </span>
                          </div>
                        )}

                        {consumidor?.email && (
                          <div style={estiloLinhaConsumidor}>
                            <span style={estiloLabelResumo}>E-mail</span>
                            <span style={estiloValorConsumidor}>
                              {consumidor.email}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                  </>)
              )
      }

    </div>
  );
};


const estiloContainerButtons = {
  width: '100%',
  maxWidth: '680px',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
  marginTop: 10
};

const estiloButtonsRow = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '14px',
};

const estiloBotao = {
  width: '100%',
  minHeight: '96px',
  padding: '16px 18px',
  border: '1px solid rgba(255, 255, 255, 0.15)',
  borderRadius: '14px',
  color: '#fff',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '14px',

  textAlign: 'left',
  boxSizing: 'border-box',
  cursor: 'pointer',

  boxShadow:
    '0 7px 18px rgba(0, 0, 0, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.12)',

  transition:
    'transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease',
};

const estiloIconeBotao = {
  width: '50px',
  height: '50px',
  minWidth: '50px',
  borderRadius: '13px',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  backgroundColor: 'rgba(255, 255, 255, 0.17)',
  boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.2)',

  fontSize: '25px',
  lineHeight: '1',
};

const estiloConteudoBotao = {
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
};

const estiloTituloBotao = {
  fontSize: '16px',
  fontWeight: '700',
  lineHeight: '1.2',
};

const estiloDescricaoBotao = {
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '1.3',
  opacity: 0.82,
};

const estiloP = {
  margin: "5px 0",
  fontWeight: "bold",
  fontSize: "14px",
  width: "100%",
  whiteSpace: "pre-wrap",    // mantém quebras e força quebra automática
  wordBreak: "break-word",   // força quebra em palavras longas
  overflowWrap: "break-word" // extra segurança
};
const estiloObservacao = {
  ...estiloP,
  maxHeight: "150px",  // limita a altura visível
  overflowY: "auto",   // adiciona scroll vertical se passar disso
};

const estiloGridResumoVenda = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 3fr) minmax(260px, 1fr)',
  gap: '12px',
  width: '100%',
  boxSizing: 'border-box',
  marginTop: 10
};

const estiloAreaResumoVenda = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  minWidth: 0,
};

const estiloGridCabecalho = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: '12px',
};

const estiloGridTotaisVenda = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: '12px',
};

const estiloCardPequeno = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: '68px',
  padding: '10px 14px',
  backgroundColor: '#ffffff',
  border: '1px solid #e8e8e8',
  borderRadius: '12px',
  boxShadow: '0 3px 12px rgba(0, 0, 0, 0.04)',
  boxSizing: 'border-box',
  minWidth: 0,
};

const estiloCardFinanceiro = {
  padding: '14px',
  backgroundColor: '#ffffff',
  border: '1px solid #e8e8e8',
  borderRadius: '12px',
  boxShadow: '0 3px 12px rgba(0, 0, 0, 0.04)',
  boxSizing: 'border-box',
};

const estiloTituloCardFinanceiro = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '14px',
  color: '#222222',
  fontSize: '15px',
  fontWeight: '700',
};

const estiloGridFinanceiro = {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  gap: '10px',
};

const estiloItemFinanceiro = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minWidth: 0,
};

const estiloLabelResumo = {
  color: '#777777',
  fontSize: '12px',
  fontWeight: '600',
};

const estiloValorResumo = {
  color: '#222222',
  fontSize: '15px',
  fontWeight: '700',
  wordBreak: 'break-word',
};

const estiloTotalFinanceiro = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  marginTop: '14px',
  paddingTop: '12px',
  borderTop: '2px solid #eeeeee',
};

const estiloLabelTotalFinanceiro = {
  color: '#222222',
  fontSize: '15px',
  fontWeight: '700',
};

const estiloValorTotalFinanceiro = {
  color: '#16a34a',
  fontSize: '20px',
  fontWeight: '800',
};

const estiloCardConsumidor = {
  padding: '16px',
  backgroundColor: '#ffffff',
  border: '1px solid #e8e8e8',
  borderRadius: '12px',
  boxShadow: '0 3px 12px rgba(0, 0, 0, 0.04)',
  boxSizing: 'border-box',
  minWidth: 0,
};

const estiloTituloConsumidor = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '14px',
  color: '#222222',
  fontSize: '16px',
  fontWeight: '700',
};

const estiloLinhaConsumidor = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  padding: '7px 0',
  borderBottom: '1px solid #f0f0f0',
};

const estiloValorConsumidor = {
  color: '#222222',
  fontSize: '13px',
  fontWeight: '600',
  wordBreak: 'break-word',
};




export default FinalizarVenda;